webpackJsonp([6,23],{

/***/ 353:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(34)(
  /* script */
  __webpack_require__(716),
  /* template */
  __webpack_require__(718),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 364:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(34)(
  /* script */
  __webpack_require__(730),
  /* template */
  __webpack_require__(811),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 716:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_app_cfg__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__config_app_cfg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_handy__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_handy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__utils_handy__);
//
//
//
//
//
//
//
//



var JsPDF = __webpack_require__(352);
__webpack_require__(717);

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['headers', 'items', 'title', 'subtitle', 'tablefooter', 'letterHead', 'landscape', 'fontsize', 'cellpadding', 'legend'],
  methods: {
    download: function download(type) {
      var _this = this;

      /* NOTE:
      Making use of PDF plug-in to generate CSV file as well
      */
      // construnct cols from passed table heading
      var cols = [];
      var colStyle = {};
      var colFormat = [];
      this.headers.forEach(function (rec) {
        if (rec.text) {
          // column title and value key
          cols.push({ title: rec.text, dataKey: rec.value });
          // column style if any
          if (rec.align || rec.columnWidth) {
            colStyle[rec.value] = {};
            if (rec.align) {
              colStyle[rec.value].halign = rec.align;
            }
            if (rec.columnWidth) {
              colStyle[rec.value].columnWidth = rec.columnWidth;
            }
          }
          // column format if any
          colFormat[rec.value] = rec.format;
        }
      });
      // local copy for later use
      var locItems = this.items;

      // pdf
      var doc = null;
      if (this.landscape) {
        doc = new JsPDF('landscape');
      } else {
        doc = new JsPDF();
      }

      var totalPagesExp = '{total_pages_count_string}';
      var pageContent = function pageContent(data) {
        // HEADER
        doc.setFontSize(20);
        doc.setFontStyle('normal');
        // a. community details
        if (!_this.letterHead) {
          doc.setTextColor(139, 195, 74);
          doc.text(__WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.COMM_NAME, data.settings.margin.left, 15);
          doc.setDrawColor(241, 241, 241);
          doc.line(0, 20, doc.internal.pageSize.width || doc.internal.pageSize.getWidth(), 20);
        }
        doc.setTextColor(40);

        // b. report heading
        doc.setFontSize(16);
        doc.text(_this.title, data.settings.margin.left, 30);
        // c. report subheading
        if (_this.subtitle) {
          doc.setFontSize(10);
          doc.text(_this.subtitle, data.settings.margin.left, 35);
        }

        // FOOTER
        var str = 'Page ' + data.pageCount;
        // Total page number plugin only available in jspdf v1.0+
        if (typeof doc.putTotalPages === 'function') {
          str = str + ' of ' + totalPagesExp;
        }
        doc.setFontSize(10);
        var pageHeight = doc.internal.pageSize.height || doc.internal.pageSize.getHeight();
        doc.text(str + '\nDownloaded By ' + __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.CUST_NAME + ' On ' + __WEBPACK_IMPORTED_MODULE_1__utils_handy___default.a.formatDate(new Date()) + ' ' + __WEBPACK_IMPORTED_MODULE_1__utils_handy___default.a.getTime12Hrs(new Date()), data.settings.margin.left, pageHeight - 10);
      };

      // FULL CONTENT
      var csvHeader = '';
      var csvCont = [];
      var csvLine = [];
      doc.autoTable(cols, this.items, {
        theme: 'grid',
        addPageContent: pageContent,
        margin: { top: this.subtitle ? 40 : 35 },
        columnStyles: colStyle,
        styles: {
          fontSize: this.fontsize || 10,
          cellPadding: this.cellpadding || 2,
          overflow: 'linebreak'
        },
        createdCell: function createdCell(cell, data) {
          if (cell.raw === null) {
            // special handling for nulls
            cell.text[0] = '';
            cell.raw = '';
          } else if (colFormat[data.column.dataKey]) {
            // formatting
            // format as requested
            cell.text[0] = __WEBPACK_IMPORTED_MODULE_1__utils_handy___default.a[colFormat[data.column.dataKey]](cell.raw);
          } else if (data.column.dataKey.indexOf('_list') < 0 && (data.column.dataKey.indexOf('_dt') >= 0 || data.column.dataKey.indexOf('_date') >= 0 || data.column.dataKey.indexOf('_on') >= 0)) {
            // special handling for dates
            cell.text[0] = __WEBPACK_IMPORTED_MODULE_1__utils_handy___default.a.formatDate(cell.raw);
          } else if (data.column.dataKey.indexOf('_time') >= 0 || data.column.dataKey.indexOf('_in') >= 0 || data.column.dataKey.indexOf('_out') >= 0) {
            // special handling for date time
            cell.text[0] = __WEBPACK_IMPORTED_MODULE_1__utils_handy___default.a.formatDisplayDateTime(cell.raw);
          } else if (data.column.raw.title.indexOf('?') >= 0) {
            // special handling boolean
            if (cell.raw === 0 || cell.raw === 1 || typeof cell.raw === 'boolean') {
              cell.text[0] = !cell.raw ? 'No' : 'Yes';
            }
          }
        },
        drawRow: function drawRow(row, data) {
          // used for CSV & to highlight footer
          csvLine = [];
          for (var col in row.cells) {
            if (row.cells[col].text.length) {
              csvLine.push('"' + (row.cells[col].raw && row.cells[col].raw.length > 1 ? row.cells[col].raw : row.cells[col].text) + '"');
            }
            if (locItems[row.index].styles) {
              // highlight / style row if required
              for (var atr in locItems[row.index].styles) {
                row.cells[col].styles[atr] = locItems[row.index].styles[atr];
              }
            }
          }
          if (!csvCont[row.index] && csvLine.length) {
            csvCont[row.index] = csvLine.join();
          }
        }
      });

      // table legend
      if (this.legend) {
        doc.setFontSize(8);
        doc.text(this.legend, 15, doc.autoTable.previous.finalY + 4);
      }

      // table footer
      if (this.tablefooter) {
        doc.setFontSize(12);
        doc.text(this.tablefooter, 15, doc.autoTable.previous.finalY + 10);
      }

      // page footer
      if (typeof doc.putTotalPages === 'function') {
        doc.putTotalPages(totalPagesExp);
      }

      // download
      if (type === 'PDF') {
        doc.save(this.title + '.pdf');
      } else {
        // csv
        csvHeader = cols.map(function (rec) {
          return rec.title;
        }).join() + '\n';
        csvCont = csvHeader + csvCont.filter(function (rec) {
          return rec;
        }).join('\n');
        // table footer if requested
        if (this.tablefooter) {
          csvCont += '\n' + this.tablefooter;
        }

        var blob = new Blob([csvCont]);
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob, { type: 'text/plain' });
        link.setAttribute('download', this.title + (this.subtitle ? ' ' + this.subtitle : '') + '.csv');
        document.body.appendChild(link); // Required for FF
        link.click();
        document.body.removeChild(link);
      }
    }
  }
});

/***/ }),

/***/ 717:
/***/ (function(module, exports, __webpack_require__) {

/*!
 * jsPDF AutoTable plugin v2.3.5
 * Copyright (c) 2014 Simon Bengtsson, https://github.com/simonbengtsson/jsPDF-AutoTable 
 * 
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 * 
 * * /if (typeof window === 'object') window.jspdfAutoTableVersion = '2.3.5';/*
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(352));
	else if(typeof define === 'function' && define.amd)
		define(["jspdf"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("jspdf")) : factory(root["jsPDF"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__18__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 17);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
/**
 * Ratio between font size and font height. The number comes from jspdf's source code
 */
exports.FONT_ROW_RATIO = 1.15;
var models_1 = __webpack_require__(4);
var table = null;
var assign = __webpack_require__(5);
var entries = __webpack_require__(19);
/**
 * Styles for the themes (overriding the default styles)
 */
exports.getTheme = function (name) {
    var themes = {
        'striped': {
            table: { fillColor: 255, textColor: 80, fontStyle: 'normal' },
            header: { textColor: 255, fillColor: [41, 128, 185], fontStyle: 'bold' },
            body: {},
            alternateRow: { fillColor: 245 }
        },
        'grid': {
            table: { fillColor: 255, textColor: 80, fontStyle: 'normal', lineWidth: 0.1 },
            header: { textColor: 255, fillColor: [26, 188, 156], fontStyle: 'bold', lineWidth: 0 },
            body: {},
            alternateRow: {}
        },
        'plain': {
            header: { fontStyle: 'bold' }
        }
    };
    return themes[name];
};
function getDefaults() {
    var scaleFactor = Config.scaleFactor();
    return {
        // Styling
        theme: 'striped',
        styles: {},
        headerStyles: {},
        bodyStyles: {},
        alternateRowStyles: {},
        columnStyles: {},
        // Properties
        startY: false,
        margin: 40 / scaleFactor,
        pageBreak: 'auto',
        tableWidth: 'auto',
        showHeader: 'everyPage',
        tableLineWidth: 0,
        tableLineColor: 200,
        // Hooks
        createdHeaderCell: function (cell, data) { },
        createdCell: function (cell, data) { },
        drawHeaderRow: function (row, data) { },
        drawRow: function (row, data) { },
        drawHeaderCell: function (cell, data) { },
        drawCell: function (cell, data) { },
        addPageContent: function (data) { }
    };
}
exports.getDefaults = getDefaults;
// Base style for all themes
function defaultStyles() {
    var scaleFactor = Config.scaleFactor();
    return {
        font: "helvetica",
        fontStyle: 'normal',
        overflow: 'ellipsize',
        fillColor: false,
        textColor: 20,
        halign: 'left',
        valign: 'top',
        fontSize: 10,
        cellPadding: 5 / scaleFactor,
        lineColor: 200,
        lineWidth: 0 / scaleFactor,
        columnWidth: 'auto'
    };
}
var Config = /** @class */ (function () {
    function Config() {
    }
    Config.pageSize = function () {
        var pageSize = table.doc.internal.pageSize;
        // JSPDF 1.4 uses get functions instead of properties on pageSize
        if (pageSize.width == null) {
            pageSize = {
                width: pageSize.getWidth(),
                height: pageSize.getHeight()
            };
        }
        return pageSize;
    };
    Config.applyUserStyles = function () {
        Config.applyStyles(table.userStyles);
    };
    Config.createTable = function (doc) {
        table = new models_1.Table(doc);
        return table;
    };
    Config.tableInstance = function () {
        return table;
    };
    Config.scaleFactor = function () {
        return table.doc.internal.scaleFactor;
    };
    Config.hooksData = function (additionalData) {
        if (additionalData === void 0) { additionalData = {}; }
        return assign({
            pageCount: table.pageCount,
            settings: table.settings,
            table: table,
            doc: table.doc,
            cursor: table.cursor
        }, additionalData || {});
    };
    Config.initSettings = function (table, allOptions) {
        var _loop_1 = function (styleProp) {
            var styles = allOptions.map(function (opts) { return opts[styleProp] || {}; });
            table.styles[styleProp] = assign.apply(void 0, [{}].concat(styles));
        };
        // Merge styles one level deeper
        for (var _i = 0, _a = Object.keys(table.styles); _i < _a.length; _i++) {
            var styleProp = _a[_i];
            _loop_1(styleProp);
        }
        // Append event handlers instead of replacing them
        for (var _b = 0, _c = entries(table.hooks); _b < _c.length; _b++) {
            var _d = _c[_b], hookName = _d[0], list = _d[1];
            for (var _e = 0, allOptions_1 = allOptions; _e < allOptions_1.length; _e++) {
                var opts = allOptions_1[_e];
                if (opts && opts[hookName]) {
                    list.push(opts[hookName]);
                }
            }
        }
        // Merge all other options one level
        table.settings = assign.apply(void 0, [getDefaults()].concat(allOptions));
    };
    // This is messy, only keep array and number format the next major version
    Config.marginOrPadding = function (value, defaultValue) {
        var newValue = {};
        if (Array.isArray(value)) {
            if (value.length >= 4) {
                newValue = { 'top': value[0], 'right': value[1], 'bottom': value[2], 'left': value[3] };
            }
            else if (value.length === 3) {
                newValue = { 'top': value[0], 'right': value[1], 'bottom': value[2], 'left': value[1] };
            }
            else if (value.length === 2) {
                newValue = { 'top': value[0], 'right': value[1], 'bottom': value[0], 'left': value[1] };
            }
            else if (value.length === 1) {
                value = value[0];
            }
            else {
                value = defaultValue;
            }
        }
        else if (typeof value === 'object') {
            if (value['vertical']) {
                value['top'] = value['vertical'];
                value['bottom'] = value['vertical'];
            }
            else if (value['horizontal']) {
                value['right'] = value['horizontal'];
                value['left'] = value['horizontal'];
            }
            for (var _i = 0, _a = ['top', 'right', 'bottom', 'left']; _i < _a.length; _i++) {
                var side = _a[_i];
                newValue[side] = value[side] || value[side] === 0 ? value[side] : defaultValue;
            }
        }
        if (typeof value === 'number') {
            newValue = { 'top': value, 'right': value, 'bottom': value, 'left': value };
        }
        return newValue;
    };
    Config.styles = function (styles) {
        styles = Array.isArray(styles) ? styles : [styles];
        return assign.apply(void 0, [defaultStyles()].concat(styles));
    };
    Config.applyStyles = function (styles) {
        var doc = table.doc;
        var styleModifiers = {
            fillColor: doc.setFillColor,
            textColor: doc.setTextColor,
            fontStyle: doc.setFontStyle,
            lineColor: doc.setDrawColor,
            lineWidth: doc.setLineWidth,
            font: doc.setFont,
            fontSize: doc.setFontSize
        };
        Object.keys(styleModifiers).forEach(function (name) {
            var style = styles[name];
            var modifier = styleModifiers[name];
            if (typeof style !== 'undefined') {
                if (Array.isArray(style)) {
                    modifier.apply(this, style);
                }
                else {
                    modifier(style);
                }
            }
        });
    };
    return Config;
}());
exports.Config = Config;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var fnToStr = Function.prototype.toString;

var constructorRegex = /^\s*class /;
var isES6ClassFn = function isES6ClassFn(value) {
	try {
		var fnStr = fnToStr.call(value);
		var singleStripped = fnStr.replace(/\/\/.*\n/g, '');
		var multiStripped = singleStripped.replace(/\/\*[.\s\S]*\*\//g, '');
		var spaceStripped = multiStripped.replace(/\n/mg, ' ').replace(/ {2}/g, ' ');
		return constructorRegex.test(spaceStripped);
	} catch (e) {
		return false; // not a function
	}
};

var tryFunctionObject = function tryFunctionObject(value) {
	try {
		if (isES6ClassFn(value)) { return false; }
		fnToStr.call(value);
		return true;
	} catch (e) {
		return false;
	}
};
var toStr = Object.prototype.toString;
var fnClass = '[object Function]';
var genClass = '[object GeneratorFunction]';
var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';

module.exports = function isCallable(value) {
	if (!value) { return false; }
	if (typeof value !== 'function' && typeof value !== 'object') { return false; }
	if (hasToStringTag) { return tryFunctionObject(value); }
	if (isES6ClassFn(value)) { return false; }
	var strClass = toStr.call(value);
	return strClass === fnClass || strClass === genClass;
};


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var implementation = __webpack_require__(29);

module.exports = Function.prototype.bind || implementation;


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var config_1 = __webpack_require__(0);
var painter_1 = __webpack_require__(16);
function getStringWidth(text, styles) {
    var k = config_1.Config.scaleFactor();
    var fontSize = styles.fontSize / k;
    config_1.Config.applyStyles(styles);
    text = Array.isArray(text) ? text : [text];
    var maxWidth = 0;
    text.forEach(function (line) {
        var width = config_1.Config.tableInstance().doc.getStringUnitWidth(line);
        if (width > maxWidth) {
            maxWidth = width;
        }
    });
    var precision = 10000 * k;
    maxWidth = Math.floor(maxWidth * precision) / precision;
    return maxWidth * fontSize;
}
exports.getStringWidth = getStringWidth;
/**
 * Ellipsize the text to fit in the width
 */
function ellipsize(text, width, styles, ellipsizeStr) {
    if (ellipsizeStr === void 0) { ellipsizeStr = '...'; }
    if (Array.isArray(text)) {
        var value_1 = [];
        text.forEach(function (str, i) {
            value_1[i] = ellipsize(str, width, styles, ellipsizeStr);
        });
        return value_1;
    }
    var precision = 10000 * config_1.Config.scaleFactor();
    width = Math.ceil(width * precision) / precision;
    if (width >= getStringWidth(text, styles)) {
        return text;
    }
    while (width < getStringWidth(text + ellipsizeStr, styles)) {
        if (text.length <= 1) {
            break;
        }
        text = text.substring(0, text.length - 1);
    }
    return text.trim() + ellipsizeStr;
}
exports.ellipsize = ellipsize;
function addTableBorder() {
    var table = config_1.Config.tableInstance();
    var styles = { lineWidth: table.settings.tableLineWidth, lineColor: table.settings.tableLineColor };
    config_1.Config.applyStyles(styles);
    var fs = getFillStyle(styles);
    if (fs) {
        table.doc.rect(table.pageStartX, table.pageStartY, table.width, table.cursor.y - table.pageStartY, fs);
    }
}
exports.addTableBorder = addTableBorder;
function addPage() {
    var table = config_1.Config.tableInstance();
    table.finalY = table.cursor.y;
    // Add user content just before adding new page ensure it will 
    // be drawn above other things on the page
    addContentHooks();
    addTableBorder();
    nextPage(table.doc);
    table.pageCount++;
    table.cursor = { x: table.margin('left'), y: table.margin('top') };
    table.pageStartX = table.cursor.x;
    table.pageStartY = table.cursor.y;
    if (table.settings.showHeader === true || table.settings.showHeader === 'everyPage') {
        painter_1.printRow(table.headerRow, table.hooks.drawHeaderRow, table.hooks.drawHeaderCell);
    }
}
exports.addPage = addPage;
function addContentHooks() {
    for (var _i = 0, _a = config_1.Config.tableInstance().hooks.addPageContent; _i < _a.length; _i++) {
        var hook = _a[_i];
        config_1.Config.applyUserStyles();
        hook(config_1.Config.hooksData());
    }
    config_1.Config.applyUserStyles();
}
exports.addContentHooks = addContentHooks;
function getFillStyle(styles) {
    var drawLine = styles.lineWidth > 0;
    var drawBackground = styles.fillColor || styles.fillColor === 0;
    if (drawLine && drawBackground) {
        return 'DF'; // Fill then stroke
    }
    else if (drawLine) {
        return 'S'; // Only stroke (transparent background)
    }
    else if (drawBackground) {
        return 'F'; // Only fill, no stroke
    }
    else {
        return false;
    }
}
exports.getFillStyle = getFillStyle;
function nextPage(doc) {
    var current = doc.internal.getCurrentPageInfo().pageNumber;
    doc.setPage(current + 1);
    var newCurrent = doc.internal.getCurrentPageInfo().pageNumber;
    if (newCurrent === current) {
        doc.addPage();
    }
}
exports.nextPage = nextPage;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var config_1 = __webpack_require__(0);
exports.table = {};
var Table = /** @class */ (function () {
    function Table(doc) {
        this.height = 0;
        this.width = 0;
        this.contentWidth = 0;
        this.preferredWidth = 0;
        this.rows = [];
        this.columns = [];
        this.headerRow = null;
        this.pageCount = 1;
        this.hooks = {
            createdHeaderCell: [],
            createdCell: [],
            drawHeaderRow: [],
            drawRow: [],
            drawHeaderCell: [],
            drawCell: [],
            addPageContent: []
        };
        this.styles = {
            styles: {},
            headerStyles: {},
            bodyStyles: {},
            alternateRowStyles: {},
            columnStyles: {}
        };
        this.doc = doc;
        this.userStyles = {
            textColor: 30,
            fontSize: doc.internal.getFontSize(),
            fontStyle: doc.internal.getFont().fontStyle
        };
    }
    Table.prototype.margin = function (side) {
        return config_1.Config.marginOrPadding(this.settings.margin, config_1.getDefaults().margin)[side];
    };
    return Table;
}());
exports.Table = Table;
var Row = /** @class */ (function () {
    function Row(raw, index) {
        this.cells = {};
        this.spansMultiplePages = false;
        this.pageCount = 1;
        this.height = 0;
        this.y = 0;
        this.maxLineCount = 1;
        this.raw = raw;
        this.index = index;
    }
    return Row;
}());
exports.Row = Row;
var Cell = /** @class */ (function () {
    function Cell(raw) {
        this.styles = {};
        this.text = '';
        this.contentWidth = 0;
        this.textPos = {};
        this.height = 0;
        this.width = 0;
        this.x = 0;
        this.y = 0;
        this.raw = raw;
    }
    Cell.prototype.padding = function (name) {
        var padding = config_1.Config.marginOrPadding(this.styles.cellPadding, config_1.Config.styles([]).cellPadding);
        if (name === 'vertical') {
            return padding.top + padding.bottom;
        }
        else if (name === 'horizontal') {
            return padding.left + padding.right;
        }
        else {
            return padding[name];
        }
    };
    return Cell;
}());
exports.Cell = Cell;
var Column = /** @class */ (function () {
    function Column(dataKey, index) {
        this.options = {};
        this.contentWidth = 0;
        this.preferredWidth = 0;
        this.widthStyle = 'auto';
        this.width = 0;
        this.x = 0;
        this.dataKey = dataKey;
        this.index = index;
    }
    return Column;
}());
exports.Column = Column;


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keys = __webpack_require__(20);
var foreach = __webpack_require__(22);
var hasSymbols = typeof Symbol === 'function' && typeof Symbol() === 'symbol';

var toStr = Object.prototype.toString;

var isFunction = function (fn) {
	return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
};

var arePropertyDescriptorsSupported = function () {
	var obj = {};
	try {
		Object.defineProperty(obj, 'x', { enumerable: false, value: obj });
        /* eslint-disable no-unused-vars, no-restricted-syntax */
        for (var _ in obj) { return false; }
        /* eslint-enable no-unused-vars, no-restricted-syntax */
		return obj.x === obj;
	} catch (e) { /* this is IE 8. */
		return false;
	}
};
var supportsDescriptors = Object.defineProperty && arePropertyDescriptorsSupported();

var defineProperty = function (object, name, value, predicate) {
	if (name in object && (!isFunction(predicate) || !predicate())) {
		return;
	}
	if (supportsDescriptors) {
		Object.defineProperty(object, name, {
			configurable: true,
			enumerable: false,
			value: value,
			writable: true
		});
	} else {
		object[name] = value;
	}
};

var defineProperties = function (object, map) {
	var predicates = arguments.length > 2 ? arguments[2] : {};
	var props = keys(map);
	if (hasSymbols) {
		props = props.concat(Object.getOwnPropertySymbols(map));
	}
	foreach(props, function (name) {
		defineProperty(object, name, map[name], predicates[name]);
	});
};

defineProperties.supportsDescriptors = !!supportsDescriptors;

module.exports = defineProperties;


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ES = __webpack_require__(23);
var has = __webpack_require__(14);
var bind = __webpack_require__(2);
var isEnumerable = bind.call(Function.call, Object.prototype.propertyIsEnumerable);

module.exports = function entries(O) {
	var obj = ES.RequireObjectCoercible(O);
	var entrys = [];
	for (var key in obj) {
		if (has(obj, key) && isEnumerable(obj, key)) {
			entrys.push([key, obj[key]]);
		}
	}
	return entrys;
};


/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = Number.isNaN || function isNaN(a) {
	return a !== a;
};


/***/ }),
/* 9 */
/***/ (function(module, exports) {

var $isNaN = Number.isNaN || function (a) { return a !== a; };

module.exports = Number.isFinite || function (x) { return typeof x === 'number' && !$isNaN(x) && x !== Infinity && x !== -Infinity; };


/***/ }),
/* 10 */
/***/ (function(module, exports) {

var has = Object.prototype.hasOwnProperty;
module.exports = Object.assign || function assign(target, source) {
	for (var key in source) {
		if (has.call(source, key)) {
			target[key] = source[key];
		}
	}
	return target;
};


/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = function sign(number) {
	return number >= 0 ? 1 : -1;
};


/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = function mod(number, modulo) {
	var remain = number % modulo;
	return Math.floor(remain >= 0 ? remain : remain + modulo);
};


/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports = function isPrimitive(value) {
	return value === null || (typeof value !== 'function' && typeof value !== 'object');
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var bind = __webpack_require__(2);

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(7);

module.exports = function getPolyfill() {
	return typeof Object.entries === 'function' ? Object.entries : implementation;
};


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var config_1 = __webpack_require__(0);
var common_1 = __webpack_require__(3);
function printFullRow(row, drawRowHooks, drawCellHooks) {
    var remainingRowHeight = 0;
    var remainingTexts = {};
    var table = config_1.Config.tableInstance();
    if (!canFitOnPage(row.height)) {
        if (row.maxLineCount <= 1) {
            common_1.addPage();
        }
        else {
            // Modify the row to fit the current page and calculate text and height of partial row
            row.spansMultiplePages = true;
            var pageHeight = config_1.Config.pageSize().height;
            var maxCellHeight = 0;
            for (var j = 0; j < table.columns.length; j++) {
                var col = table.columns[j];
                var cell = row.cells[col.dataKey];
                var fontHeight = cell.styles.fontSize / config_1.Config.scaleFactor() * config_1.FONT_ROW_RATIO;
                var vPadding = cell.padding('vertical');
                var remainingPageSpace = pageHeight - table.cursor.y - table.margin('bottom');
                var remainingLineCount = Math.floor((remainingPageSpace - vPadding) / fontHeight);
                // Splice with negative values results in unexpected results, therefore eliminate
                // scenarios where less than one line is remaining, but are shown
                if (remainingLineCount < 0) {
                    remainingLineCount = 0;
                }
                if (Array.isArray(cell.text) && cell.text.length > remainingLineCount) {
                    var remainingLines = cell.text.splice(remainingLineCount, cell.text.length);
                    remainingTexts[col.dataKey] = remainingLines;
                    var cellHeight = cell.text.length * fontHeight + vPadding;
                    if (cellHeight > maxCellHeight) {
                        maxCellHeight = cellHeight;
                    }
                    var rCellHeight = remainingLines.length * fontHeight + vPadding;
                    if (rCellHeight > remainingRowHeight) {
                        remainingRowHeight = rCellHeight;
                    }
                }
            }
            // Reset row height since text are now removed
            row.height = maxCellHeight;
        }
    }
    printRow(row, drawRowHooks, drawCellHooks);
    // Parts of the row is now printed. Time for adding a new page, prune 
    // the text and start over
    if (Object.keys(remainingTexts).length > 0) {
        for (var j = 0; j < table.columns.length; j++) {
            var col = table.columns[j];
            var cell = row.cells[col.dataKey];
            cell.text = remainingTexts[col.dataKey] || '';
        }
        common_1.addPage();
        row.pageCount++;
        row.height = remainingRowHeight;
        printFullRow(row, drawRowHooks, drawCellHooks);
    }
}
exports.printFullRow = printFullRow;
function printRow(row, drawRowHooks, drawCellHooks) {
    var table = config_1.Config.tableInstance();
    row.y = table.cursor.y;
    for (var _i = 0, drawRowHooks_1 = drawRowHooks; _i < drawRowHooks_1.length; _i++) {
        var hook = drawRowHooks_1[_i];
        if (hook(row, config_1.Config.hooksData({ row: row, addPage: common_1.addPage })) === false) {
            return;
        }
    }
    table.cursor.x = table.margin('left');
    for (var i = 0; i < table.columns.length; i++) {
        var column = table.columns[i];
        var cell = row.cells[column.dataKey];
        if (!cell) {
            continue;
        }
        config_1.Config.applyStyles(cell.styles);
        cell.x = table.cursor.x;
        cell.y = table.cursor.y;
        cell.height = row.height;
        cell.width = column.width;
        if (cell.styles.valign === 'top') {
            cell.textPos.y = table.cursor.y + cell.padding('top');
        }
        else if (cell.styles.valign === 'bottom') {
            cell.textPos.y = table.cursor.y + row.height - cell.padding('bottom');
        }
        else {
            cell.textPos.y = table.cursor.y + row.height / 2;
        }
        if (cell.styles.halign === 'right') {
            cell.textPos.x = cell.x + cell.width - cell.padding('right');
        }
        else if (cell.styles.halign === 'center') {
            cell.textPos.x = cell.x + cell.width / 2;
        }
        else {
            cell.textPos.x = cell.x + cell.padding('left');
        }
        var shouldDrawCell = true;
        var data = config_1.Config.hooksData({ column: column, row: row, addPage: common_1.addPage });
        for (var _a = 0, drawCellHooks_1 = drawCellHooks; _a < drawCellHooks_1.length; _a++) {
            var hook = drawCellHooks_1[_a];
            if (hook(cell, data) === false) {
                shouldDrawCell = false;
            }
        }
        if (shouldDrawCell) {
            var fillStyle = common_1.getFillStyle(cell.styles);
            if (fillStyle) {
                table.doc.rect(cell.x, cell.y, cell.width, cell.height, fillStyle);
            }
            table.doc.autoTableText(cell.text, cell.textPos.x, cell.textPos.y, {
                halign: cell.styles.halign,
                valign: cell.styles.valign
            });
        }
        table.cursor.x += cell.width;
    }
    table.cursor.y += row.height;
}
exports.printRow = printRow;
function canFitOnPage(rowHeight) {
    var table = config_1.Config.tableInstance();
    var pos = rowHeight + table.cursor.y + table.margin('bottom');
    return pos < config_1.Config.pageSize().height;
}


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var jsPDF = __webpack_require__(18);
var config_1 = __webpack_require__(0);
var common_1 = __webpack_require__(3);
var painter_1 = __webpack_require__(16);
var calculator_1 = __webpack_require__(34);
var creator_1 = __webpack_require__(35);
/**
 * Create a table from a set of rows and columns.
 *
 * @param {Object[]|String[]} headers Either as an array of objects or array of strings
 * @param {Object[][]|String[][]} data Either as an array of objects or array of strings
 * @param {Object} [tableOptions={}] Options that will override the default ones
 */
jsPDF.API.autoTable = function (headers, data, tableOptions) {
    if (tableOptions === void 0) { tableOptions = {}; }
    this.autoTableState = this.autoTableState || {};
    jsPDF.autoTableState = jsPDF.autoTableState || {};
    var allOptions = [jsPDF.autoTableState.defaults || {}, this.autoTableState.defaults || {}, tableOptions || {}];
    creator_1.validateInput(headers, data, allOptions);
    var table = config_1.Config.createTable(this);
    config_1.Config.initSettings(table, allOptions);
    var settings = table.settings;
    // Create the table model with its columns, rows and cells
    creator_1.createModels(headers, data);
    settings.margin = config_1.Config.marginOrPadding(settings.margin, config_1.getDefaults().margin);
    calculator_1.calculateWidths(this, config_1.Config.pageSize().width);
    table.cursor = {
        x: table.margin('left'),
        y: settings.startY === false ? table.margin('top') : settings.startY
    };
    var minTableBottomPos = settings.startY + table.margin('bottom') + table.headerRow.height;
    if (settings.pageBreak === 'avoid') {
        minTableBottomPos += table.height;
    }
    var pageHeight = config_1.Config.pageSize().height;
    if ((settings.pageBreak === 'always' && settings.startY !== false) ||
        (settings.startY !== false && minTableBottomPos > pageHeight)) {
        common_1.nextPage(table.doc);
        table.cursor.y = table.margin('top');
    }
    table.pageStartX = table.cursor.x;
    table.pageStartY = table.cursor.y;
    config_1.Config.applyUserStyles();
    if (settings.showHeader === true || settings.showHeader === 'firstPage' || settings.showHeader === 'everyPage') {
        painter_1.printRow(table.headerRow, table.hooks.drawHeaderRow, table.hooks.drawHeaderCell);
    }
    config_1.Config.applyUserStyles();
    table.rows.forEach(function (row) {
        painter_1.printFullRow(row, table.hooks.drawRow, table.hooks.drawCell);
    });
    common_1.addTableBorder();
    // Don't call global and document addPageContent more than once for each page
    var pageNumber = this.internal.getCurrentPageInfo().pageNumber;
    if (this.autoTableState.addPageHookPages && this.autoTableState.addPageHookPages[pageNumber]) {
        if (typeof tableOptions['addPageContent'] === 'function') {
            tableOptions['addPageContent'](config_1.Config.hooksData());
        }
    }
    else {
        if (!this.autoTableState.addPageHookPages)
            this.autoTableState.addPageHookPages = {};
        this.autoTableState.addPageHookPages[pageNumber] = true;
        common_1.addContentHooks();
    }
    table.finalY = table.cursor.y;
    this.autoTable.previous = table;
    config_1.Config.applyUserStyles();
    return this;
};
// Enables doc.autoTable.previous.finalY || 40;
jsPDF.API.autoTable.previous = false;
jsPDF.API.autoTableSetDefaults = function (defaults) {
    if (!this.autoTableState)
        this.autoTableState = {};
    if (defaults && typeof defaults === 'object') {
        this.autoTableState.defaults = defaults;
    }
    else {
        delete this.autoTableState.defaults;
    }
    return this;
};
jsPDF.autoTableSetDefaults = function (defaults) {
    if (!jsPDF.autoTableState)
        jsPDF.autoTableState = {};
    if (defaults && typeof defaults === 'object') {
        this.autoTableState.defaults = defaults;
    }
    else {
        delete this.autoTableState.defaults;
    }
    jsPDF.autoTableState.defaults = defaults;
};
/**
 * Parses an html table
 *
 * @param tableElem Html table element
 * @param includeHiddenElements If to include hidden rows and columns (defaults to false)
 * @returns Object Object with two properties, columns and rows
 */
jsPDF.API.autoTableHtmlToJson = function (tableElem, includeHiddenElements) {
    includeHiddenElements = includeHiddenElements || false;
    if (!tableElem || !(tableElem instanceof HTMLTableElement)) {
        console.error("A HTMLTableElement has to be sent to autoTableHtmlToJson");
        return null;
    }
    var columns = {}, rows = [];
    var header = tableElem.rows[0];
    for (var i = 0; i < header.cells.length; i++) {
        var cell = header.cells[i];
        var style = window.getComputedStyle(cell);
        if (includeHiddenElements || style.display !== 'none') {
            columns[i] = cell;
        }
    }
    var _loop_1 = function (i) {
        var tableRow = tableElem.rows[i];
        var style = window.getComputedStyle(tableRow);
        if (includeHiddenElements || style.display !== 'none') {
            var rowData_1 = [];
            Object.keys(columns).forEach(function (key) {
                var cell = tableRow.cells[key];
                rowData_1.push(cell);
            });
            rows.push(rowData_1);
        }
    };
    for (var i = 1; i < tableElem.rows.length; i++) {
        _loop_1(i);
    }
    var values = Object.keys(columns).map(function (key) { return columns[key]; });
    return { columns: values, rows: rows, data: rows };
};
/**
 * Improved text function with halign and valign support
 * Inspiration from: http://stackoverflow.com/questions/28327510/align-text-right-using-jspdf/28433113#28433113
 */
jsPDF.API.autoTableText = function (text, x, y, styles) {
    if (typeof x !== 'number' || typeof y !== 'number') {
        console.error('The x and y parameters are required. Missing for the text: ', text);
    }
    var k = this.internal.scaleFactor;
    var fontSize = this.internal.getFontSize() / k;
    var splitRegex = /\r\n|\r|\n/g;
    var splitText = null;
    var lineCount = 1;
    if (styles.valign === 'middle' || styles.valign === 'bottom' || styles.halign === 'center' || styles.halign === 'right') {
        splitText = typeof text === 'string' ? text.split(splitRegex) : text;
        lineCount = splitText.length || 1;
    }
    // Align the top
    y += fontSize * (2 - config_1.FONT_ROW_RATIO);
    if (styles.valign === 'middle')
        y -= (lineCount / 2) * fontSize * config_1.FONT_ROW_RATIO;
    else if (styles.valign === 'bottom')
        y -= lineCount * fontSize * config_1.FONT_ROW_RATIO;
    if (styles.halign === 'center' || styles.halign === 'right') {
        var alignSize = fontSize;
        if (styles.halign === 'center')
            alignSize *= 0.5;
        if (lineCount >= 1) {
            for (var iLine = 0; iLine < splitText.length; iLine++) {
                this.text(splitText[iLine], x - this.getStringUnitWidth(splitText[iLine]) * alignSize, y);
                y += fontSize;
            }
            return this;
        }
        x -= this.getStringUnitWidth(text) * alignSize;
    }
    this.text(text, x, y);
    return this;
};
/**
 * @deprecated Use doc.autoTable.previous.finalY instead
 */
jsPDF.API.autoTableEndPosY = function () {
    var prev = this.autoTable.previous;
    if (prev.cursor && typeof prev.cursor.y === 'number') {
        return prev.cursor.y;
    }
    else {
        return 0;
    }
};
/**
 * @deprecated Use jsPDF.autoTableSetDefaults({addPageContent: function() {}}) instead
 */
jsPDF.API.autoTableAddPageContent = function (hook) {
    if (!jsPDF.API.autoTable.globalDefaults) {
        jsPDF.API.autoTable.globalDefaults = {};
    }
    jsPDF.API.autoTable.globalDefaults.addPageContent = hook;
    return this;
};
/**
 * @deprecated Use data.addPage in hooks instead
 */
jsPDF.API.autoTableAddPage = function () {
    common_1.addPage();
    return this;
};


/***/ }),
/* 18 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__18__;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(6);

var implementation = __webpack_require__(7);
var getPolyfill = __webpack_require__(15);
var shim = __webpack_require__(33);

var polyfill = getPolyfill();

define(polyfill, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = polyfill;


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// modified from https://github.com/es-shims/es5-shim
var has = Object.prototype.hasOwnProperty;
var toStr = Object.prototype.toString;
var slice = Array.prototype.slice;
var isArgs = __webpack_require__(21);
var isEnumerable = Object.prototype.propertyIsEnumerable;
var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
var dontEnums = [
	'toString',
	'toLocaleString',
	'valueOf',
	'hasOwnProperty',
	'isPrototypeOf',
	'propertyIsEnumerable',
	'constructor'
];
var equalsConstructorPrototype = function (o) {
	var ctor = o.constructor;
	return ctor && ctor.prototype === o;
};
var excludedKeys = {
	$console: true,
	$external: true,
	$frame: true,
	$frameElement: true,
	$frames: true,
	$innerHeight: true,
	$innerWidth: true,
	$outerHeight: true,
	$outerWidth: true,
	$pageXOffset: true,
	$pageYOffset: true,
	$parent: true,
	$scrollLeft: true,
	$scrollTop: true,
	$scrollX: true,
	$scrollY: true,
	$self: true,
	$webkitIndexedDB: true,
	$webkitStorageInfo: true,
	$window: true
};
var hasAutomationEqualityBug = (function () {
	/* global window */
	if (typeof window === 'undefined') { return false; }
	for (var k in window) {
		try {
			if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
				try {
					equalsConstructorPrototype(window[k]);
				} catch (e) {
					return true;
				}
			}
		} catch (e) {
			return true;
		}
	}
	return false;
}());
var equalsConstructorPrototypeIfNotBuggy = function (o) {
	/* global window */
	if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
		return equalsConstructorPrototype(o);
	}
	try {
		return equalsConstructorPrototype(o);
	} catch (e) {
		return false;
	}
};

var keysShim = function keys(object) {
	var isObject = object !== null && typeof object === 'object';
	var isFunction = toStr.call(object) === '[object Function]';
	var isArguments = isArgs(object);
	var isString = isObject && toStr.call(object) === '[object String]';
	var theKeys = [];

	if (!isObject && !isFunction && !isArguments) {
		throw new TypeError('Object.keys called on a non-object');
	}

	var skipProto = hasProtoEnumBug && isFunction;
	if (isString && object.length > 0 && !has.call(object, 0)) {
		for (var i = 0; i < object.length; ++i) {
			theKeys.push(String(i));
		}
	}

	if (isArguments && object.length > 0) {
		for (var j = 0; j < object.length; ++j) {
			theKeys.push(String(j));
		}
	} else {
		for (var name in object) {
			if (!(skipProto && name === 'prototype') && has.call(object, name)) {
				theKeys.push(String(name));
			}
		}
	}

	if (hasDontEnumBug) {
		var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

		for (var k = 0; k < dontEnums.length; ++k) {
			if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
				theKeys.push(dontEnums[k]);
			}
		}
	}
	return theKeys;
};

keysShim.shim = function shimObjectKeys() {
	if (Object.keys) {
		var keysWorksWithArguments = (function () {
			// Safari 5.0 bug
			return (Object.keys(arguments) || '').length === 2;
		}(1, 2));
		if (!keysWorksWithArguments) {
			var originalKeys = Object.keys;
			Object.keys = function keys(object) {
				if (isArgs(object)) {
					return originalKeys(slice.call(object));
				} else {
					return originalKeys(object);
				}
			};
		}
	} else {
		Object.keys = keysShim;
	}
	return Object.keys || keysShim;
};

module.exports = keysShim;


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;

module.exports = function isArguments(value) {
	var str = toStr.call(value);
	var isArgs = str === '[object Arguments]';
	if (!isArgs) {
		isArgs = str !== '[object Array]' &&
			value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			toStr.call(value.callee) === '[object Function]';
	}
	return isArgs;
};


/***/ }),
/* 22 */
/***/ (function(module, exports) {


var hasOwn = Object.prototype.hasOwnProperty;
var toString = Object.prototype.toString;

module.exports = function forEach (obj, fn, ctx) {
    if (toString.call(fn) !== '[object Function]') {
        throw new TypeError('iterator must be a function');
    }
    var l = obj.length;
    if (l === +l) {
        for (var i = 0; i < l; i++) {
            fn.call(ctx, obj[i], i, obj);
        }
    } else {
        for (var k in obj) {
            if (hasOwn.call(obj, k)) {
                fn.call(ctx, obj[k], k, obj);
            }
        }
    }
};



/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ES6 = __webpack_require__(24);
var assign = __webpack_require__(10);

var ES7 = assign(ES6, {
	// https://github.com/tc39/ecma262/pull/60
	SameValueNonNumber: function SameValueNonNumber(x, y) {
		if (typeof x === 'number' || typeof x !== typeof y) {
			throw new TypeError('SameValueNonNumber requires two non-number values of the same type.');
		}
		return this.SameValue(x, y);
	}
});

module.exports = ES7;


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;
var hasSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol';
var symbolToStr = hasSymbols ? Symbol.prototype.toString : toStr;

var $isNaN = __webpack_require__(8);
var $isFinite = __webpack_require__(9);
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || Math.pow(2, 53) - 1;

var assign = __webpack_require__(10);
var sign = __webpack_require__(11);
var mod = __webpack_require__(12);
var isPrimitive = __webpack_require__(25);
var toPrimitive = __webpack_require__(26);
var parseInteger = parseInt;
var bind = __webpack_require__(2);
var strSlice = bind.call(Function.call, String.prototype.slice);
var isBinary = bind.call(Function.call, RegExp.prototype.test, /^0b[01]+$/i);
var isOctal = bind.call(Function.call, RegExp.prototype.test, /^0o[0-7]+$/i);
var nonWS = ['\u0085', '\u200b', '\ufffe'].join('');
var nonWSregex = new RegExp('[' + nonWS + ']', 'g');
var hasNonWS = bind.call(Function.call, RegExp.prototype.test, nonWSregex);
var invalidHexLiteral = /^[-+]0x[0-9a-f]+$/i;
var isInvalidHexLiteral = bind.call(Function.call, RegExp.prototype.test, invalidHexLiteral);

// whitespace from: http://es5.github.io/#x15.5.4.20
// implementation from https://github.com/es-shims/es5-shim/blob/v3.4.0/es5-shim.js#L1304-L1324
var ws = [
	'\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003',
	'\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028',
	'\u2029\uFEFF'
].join('');
var trimRegex = new RegExp('(^[' + ws + ']+)|([' + ws + ']+$)', 'g');
var replace = bind.call(Function.call, String.prototype.replace);
var trim = function (value) {
	return replace(value, trimRegex, '');
};

var ES5 = __webpack_require__(30);

var hasRegExpMatcher = __webpack_require__(32);

// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-abstract-operations
var ES6 = assign(assign({}, ES5), {

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-call-f-v-args
	Call: function Call(F, V) {
		var args = arguments.length > 2 ? arguments[2] : [];
		if (!this.IsCallable(F)) {
			throw new TypeError(F + ' is not a function');
		}
		return F.apply(V, args);
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toprimitive
	ToPrimitive: toPrimitive,

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toboolean
	// ToBoolean: ES5.ToBoolean,

	// http://www.ecma-international.org/ecma-262/6.0/#sec-tonumber
	ToNumber: function ToNumber(argument) {
		var value = isPrimitive(argument) ? argument : toPrimitive(argument, 'number');
		if (typeof value === 'symbol') {
			throw new TypeError('Cannot convert a Symbol value to a number');
		}
		if (typeof value === 'string') {
			if (isBinary(value)) {
				return this.ToNumber(parseInteger(strSlice(value, 2), 2));
			} else if (isOctal(value)) {
				return this.ToNumber(parseInteger(strSlice(value, 2), 8));
			} else if (hasNonWS(value) || isInvalidHexLiteral(value)) {
				return NaN;
			} else {
				var trimmed = trim(value);
				if (trimmed !== value) {
					return this.ToNumber(trimmed);
				}
			}
		}
		return Number(value);
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tointeger
	// ToInteger: ES5.ToNumber,

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toint32
	// ToInt32: ES5.ToInt32,

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint32
	// ToUint32: ES5.ToUint32,

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toint16
	ToInt16: function ToInt16(argument) {
		var int16bit = this.ToUint16(argument);
		return int16bit >= 0x8000 ? int16bit - 0x10000 : int16bit;
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint16
	// ToUint16: ES5.ToUint16,

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toint8
	ToInt8: function ToInt8(argument) {
		var int8bit = this.ToUint8(argument);
		return int8bit >= 0x80 ? int8bit - 0x100 : int8bit;
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint8
	ToUint8: function ToUint8(argument) {
		var number = this.ToNumber(argument);
		if ($isNaN(number) || number === 0 || !$isFinite(number)) { return 0; }
		var posInt = sign(number) * Math.floor(Math.abs(number));
		return mod(posInt, 0x100);
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint8clamp
	ToUint8Clamp: function ToUint8Clamp(argument) {
		var number = this.ToNumber(argument);
		if ($isNaN(number) || number <= 0) { return 0; }
		if (number >= 0xFF) { return 0xFF; }
		var f = Math.floor(argument);
		if (f + 0.5 < number) { return f + 1; }
		if (number < f + 0.5) { return f; }
		if (f % 2 !== 0) { return f + 1; }
		return f;
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tostring
	ToString: function ToString(argument) {
		if (typeof argument === 'symbol') {
			throw new TypeError('Cannot convert a Symbol value to a string');
		}
		return String(argument);
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toobject
	ToObject: function ToObject(value) {
		this.RequireObjectCoercible(value);
		return Object(value);
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-topropertykey
	ToPropertyKey: function ToPropertyKey(argument) {
		var key = this.ToPrimitive(argument, String);
		return typeof key === 'symbol' ? symbolToStr.call(key) : this.ToString(key);
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
	ToLength: function ToLength(argument) {
		var len = this.ToInteger(argument);
		if (len <= 0) { return 0; } // includes converting -0 to +0
		if (len > MAX_SAFE_INTEGER) { return MAX_SAFE_INTEGER; }
		return len;
	},

	// http://www.ecma-international.org/ecma-262/6.0/#sec-canonicalnumericindexstring
	CanonicalNumericIndexString: function CanonicalNumericIndexString(argument) {
		if (toStr.call(argument) !== '[object String]') {
			throw new TypeError('must be a string');
		}
		if (argument === '-0') { return -0; }
		var n = this.ToNumber(argument);
		if (this.SameValue(this.ToString(n), argument)) { return n; }
		return void 0;
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-requireobjectcoercible
	RequireObjectCoercible: ES5.CheckObjectCoercible,

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isarray
	IsArray: Array.isArray || function IsArray(argument) {
		return toStr.call(argument) === '[object Array]';
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-iscallable
	// IsCallable: ES5.IsCallable,

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isconstructor
	IsConstructor: function IsConstructor(argument) {
		return typeof argument === 'function' && !!argument.prototype; // unfortunately there's no way to truly check this without try/catch `new argument`
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isextensible-o
	IsExtensible: function IsExtensible(obj) {
		if (!Object.preventExtensions) { return true; }
		if (isPrimitive(obj)) {
			return false;
		}
		return Object.isExtensible(obj);
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isinteger
	IsInteger: function IsInteger(argument) {
		if (typeof argument !== 'number' || $isNaN(argument) || !$isFinite(argument)) {
			return false;
		}
		var abs = Math.abs(argument);
		return Math.floor(abs) === abs;
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-ispropertykey
	IsPropertyKey: function IsPropertyKey(argument) {
		return typeof argument === 'string' || typeof argument === 'symbol';
	},

	// http://www.ecma-international.org/ecma-262/6.0/#sec-isregexp
	IsRegExp: function IsRegExp(argument) {
		if (!argument || typeof argument !== 'object') {
			return false;
		}
		if (hasSymbols) {
			var isRegExp = argument[Symbol.match];
			if (typeof isRegExp !== 'undefined') {
				return ES5.ToBoolean(isRegExp);
			}
		}
		return hasRegExpMatcher(argument);
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevalue
	// SameValue: ES5.SameValue,

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevaluezero
	SameValueZero: function SameValueZero(x, y) {
		return (x === y) || ($isNaN(x) && $isNaN(y));
	},

	/**
	 * 7.3.2 GetV (V, P)
	 * 1. Assert: IsPropertyKey(P) is true.
	 * 2. Let O be ToObject(V).
	 * 3. ReturnIfAbrupt(O).
	 * 4. Return O.[[Get]](P, V).
	 */
	GetV: function GetV(V, P) {
		// 7.3.2.1
		if (!this.IsPropertyKey(P)) {
			throw new TypeError('Assertion failed: IsPropertyKey(P) is not true');
		}

		// 7.3.2.2-3
		var O = this.ToObject(V);

		// 7.3.2.4
		return O[P];
	},

	/**
	 * 7.3.9 - http://www.ecma-international.org/ecma-262/6.0/#sec-getmethod
	 * 1. Assert: IsPropertyKey(P) is true.
	 * 2. Let func be GetV(O, P).
	 * 3. ReturnIfAbrupt(func).
	 * 4. If func is either undefined or null, return undefined.
	 * 5. If IsCallable(func) is false, throw a TypeError exception.
	 * 6. Return func.
	 */
	GetMethod: function GetMethod(O, P) {
		// 7.3.9.1
		if (!this.IsPropertyKey(P)) {
			throw new TypeError('Assertion failed: IsPropertyKey(P) is not true');
		}

		// 7.3.9.2
		var func = this.GetV(O, P);

		// 7.3.9.4
		if (func == null) {
			return undefined;
		}

		// 7.3.9.5
		if (!this.IsCallable(func)) {
			throw new TypeError(P + 'is not a function');
		}

		// 7.3.9.6
		return func;
	},

	/**
	 * 7.3.1 Get (O, P) - http://www.ecma-international.org/ecma-262/6.0/#sec-get-o-p
	 * 1. Assert: Type(O) is Object.
	 * 2. Assert: IsPropertyKey(P) is true.
	 * 3. Return O.[[Get]](P, O).
	 */
	Get: function Get(O, P) {
		// 7.3.1.1
		if (this.Type(O) !== 'Object') {
			throw new TypeError('Assertion failed: Type(O) is not Object');
		}
		// 7.3.1.2
		if (!this.IsPropertyKey(P)) {
			throw new TypeError('Assertion failed: IsPropertyKey(P) is not true');
		}
		// 7.3.1.3
		return O[P];
	},

	Type: function Type(x) {
		if (typeof x === 'symbol') {
			return 'Symbol';
		}
		return ES5.Type(x);
	},

	// http://www.ecma-international.org/ecma-262/6.0/#sec-speciesconstructor
	SpeciesConstructor: function SpeciesConstructor(O, defaultConstructor) {
		if (this.Type(O) !== 'Object') {
			throw new TypeError('Assertion failed: Type(O) is not Object');
		}
		var C = O.constructor;
		if (typeof C === 'undefined') {
			return defaultConstructor;
		}
		if (this.Type(C) !== 'Object') {
			throw new TypeError('O.constructor is not an Object');
		}
		var S = hasSymbols && Symbol.species ? C[Symbol.species] : undefined;
		if (S == null) {
			return defaultConstructor;
		}
		if (this.IsConstructor(S)) {
			return S;
		}
		throw new TypeError('no constructor found');
	}
});

delete ES6.CheckObjectCoercible; // renamed in ES6 to RequireObjectCoercible

module.exports = ES6;


/***/ }),
/* 25 */
/***/ (function(module, exports) {

module.exports = function isPrimitive(value) {
	return value === null || (typeof value !== 'function' && typeof value !== 'object');
};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hasSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol';

var isPrimitive = __webpack_require__(13);
var isCallable = __webpack_require__(1);
var isDate = __webpack_require__(27);
var isSymbol = __webpack_require__(28);

var ordinaryToPrimitive = function OrdinaryToPrimitive(O, hint) {
	if (typeof O === 'undefined' || O === null) {
		throw new TypeError('Cannot call method on ' + O);
	}
	if (typeof hint !== 'string' || (hint !== 'number' && hint !== 'string')) {
		throw new TypeError('hint must be "string" or "number"');
	}
	var methodNames = hint === 'string' ? ['toString', 'valueOf'] : ['valueOf', 'toString'];
	var method, result, i;
	for (i = 0; i < methodNames.length; ++i) {
		method = O[methodNames[i]];
		if (isCallable(method)) {
			result = method.call(O);
			if (isPrimitive(result)) {
				return result;
			}
		}
	}
	throw new TypeError('No default value');
};

var GetMethod = function GetMethod(O, P) {
	var func = O[P];
	if (func !== null && typeof func !== 'undefined') {
		if (!isCallable(func)) {
			throw new TypeError(func + ' returned for property ' + P + ' of object ' + O + ' is not a function');
		}
		return func;
	}
};

// http://www.ecma-international.org/ecma-262/6.0/#sec-toprimitive
module.exports = function ToPrimitive(input, PreferredType) {
	if (isPrimitive(input)) {
		return input;
	}
	var hint = 'default';
	if (arguments.length > 1) {
		if (PreferredType === String) {
			hint = 'string';
		} else if (PreferredType === Number) {
			hint = 'number';
		}
	}

	var exoticToPrim;
	if (hasSymbols) {
		if (Symbol.toPrimitive) {
			exoticToPrim = GetMethod(input, Symbol.toPrimitive);
		} else if (isSymbol(input)) {
			exoticToPrim = Symbol.prototype.valueOf;
		}
	}
	if (typeof exoticToPrim !== 'undefined') {
		var result = exoticToPrim.call(input, hint);
		if (isPrimitive(result)) {
			return result;
		}
		throw new TypeError('unable to convert exotic object to primitive');
	}
	if (hint === 'default' && (isDate(input) || isSymbol(input))) {
		hint = 'string';
	}
	return ordinaryToPrimitive(input, hint === 'default' ? 'number' : hint);
};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getDay = Date.prototype.getDay;
var tryDateObject = function tryDateObject(value) {
	try {
		getDay.call(value);
		return true;
	} catch (e) {
		return false;
	}
};

var toStr = Object.prototype.toString;
var dateClass = '[object Date]';
var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';

module.exports = function isDateObject(value) {
	if (typeof value !== 'object' || value === null) { return false; }
	return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;
var hasSymbols = typeof Symbol === 'function' && typeof Symbol() === 'symbol';

if (hasSymbols) {
	var symToStr = Symbol.prototype.toString;
	var symStringRegex = /^Symbol\(.*\)$/;
	var isSymbolObject = function isSymbolObject(value) {
		if (typeof value.valueOf() !== 'symbol') { return false; }
		return symStringRegex.test(symToStr.call(value));
	};
	module.exports = function isSymbol(value) {
		if (typeof value === 'symbol') { return true; }
		if (toStr.call(value) !== '[object Symbol]') { return false; }
		try {
			return isSymbolObject(value);
		} catch (e) {
			return false;
		}
	};
} else {
	module.exports = function isSymbol(value) {
		// this environment does not support Symbols.
		return false;
	};
}


/***/ }),
/* 29 */
/***/ (function(module, exports) {

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr = Object.prototype.toString;
var funcType = '[object Function]';

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $isNaN = __webpack_require__(8);
var $isFinite = __webpack_require__(9);

var sign = __webpack_require__(11);
var mod = __webpack_require__(12);

var IsCallable = __webpack_require__(1);
var toPrimitive = __webpack_require__(31);

// https://es5.github.io/#x9
var ES5 = {
	ToPrimitive: toPrimitive,

	ToBoolean: function ToBoolean(value) {
		return Boolean(value);
	},
	ToNumber: function ToNumber(value) {
		return Number(value);
	},
	ToInteger: function ToInteger(value) {
		var number = this.ToNumber(value);
		if ($isNaN(number)) { return 0; }
		if (number === 0 || !$isFinite(number)) { return number; }
		return sign(number) * Math.floor(Math.abs(number));
	},
	ToInt32: function ToInt32(x) {
		return this.ToNumber(x) >> 0;
	},
	ToUint32: function ToUint32(x) {
		return this.ToNumber(x) >>> 0;
	},
	ToUint16: function ToUint16(value) {
		var number = this.ToNumber(value);
		if ($isNaN(number) || number === 0 || !$isFinite(number)) { return 0; }
		var posInt = sign(number) * Math.floor(Math.abs(number));
		return mod(posInt, 0x10000);
	},
	ToString: function ToString(value) {
		return String(value);
	},
	ToObject: function ToObject(value) {
		this.CheckObjectCoercible(value);
		return Object(value);
	},
	CheckObjectCoercible: function CheckObjectCoercible(value, optMessage) {
		/* jshint eqnull:true */
		if (value == null) {
			throw new TypeError(optMessage || 'Cannot call method on ' + value);
		}
		return value;
	},
	IsCallable: IsCallable,
	SameValue: function SameValue(x, y) {
		if (x === y) { // 0 === -0, but they are not identical.
			if (x === 0) { return 1 / x === 1 / y; }
			return true;
		}
		return $isNaN(x) && $isNaN(y);
	},

	// http://www.ecma-international.org/ecma-262/5.1/#sec-8
	Type: function Type(x) {
		if (x === null) {
			return 'Null';
		}
		if (typeof x === 'undefined') {
			return 'Undefined';
		}
		if (typeof x === 'function' || typeof x === 'object') {
			return 'Object';
		}
		if (typeof x === 'number') {
			return 'Number';
		}
		if (typeof x === 'boolean') {
			return 'Boolean';
		}
		if (typeof x === 'string') {
			return 'String';
		}
	}
};

module.exports = ES5;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;

var isPrimitive = __webpack_require__(13);

var isCallable = __webpack_require__(1);

// https://es5.github.io/#x8.12
var ES5internalSlots = {
	'[[DefaultValue]]': function (O, hint) {
		var actualHint = hint || (toStr.call(O) === '[object Date]' ? String : Number);

		if (actualHint === String || actualHint === Number) {
			var methods = actualHint === String ? ['toString', 'valueOf'] : ['valueOf', 'toString'];
			var value, i;
			for (i = 0; i < methods.length; ++i) {
				if (isCallable(O[methods[i]])) {
					value = O[methods[i]]();
					if (isPrimitive(value)) {
						return value;
					}
				}
			}
			throw new TypeError('No default value');
		}
		throw new TypeError('invalid [[DefaultValue]] hint supplied');
	}
};

// https://es5.github.io/#x9
module.exports = function ToPrimitive(input, PreferredType) {
	if (isPrimitive(input)) {
		return input;
	}
	return ES5internalSlots['[[DefaultValue]]'](input, PreferredType);
};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = __webpack_require__(14);
var regexExec = RegExp.prototype.exec;
var gOPD = Object.getOwnPropertyDescriptor;

var tryRegexExecCall = function tryRegexExec(value) {
	try {
		var lastIndex = value.lastIndex;
		value.lastIndex = 0;

		regexExec.call(value);
		return true;
	} catch (e) {
		return false;
	} finally {
		value.lastIndex = lastIndex;
	}
};
var toStr = Object.prototype.toString;
var regexClass = '[object RegExp]';
var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';

module.exports = function isRegex(value) {
	if (!value || typeof value !== 'object') {
		return false;
	}
	if (!hasToStringTag) {
		return toStr.call(value) === regexClass;
	}

	var descriptor = gOPD(value, 'lastIndex');
	var hasLastIndexDataProperty = descriptor && has(descriptor, 'value');
	if (!hasLastIndexDataProperty) {
		return false;
	}

	return tryRegexExecCall(value);
};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getPolyfill = __webpack_require__(15);
var define = __webpack_require__(6);

module.exports = function shimEntries() {
	var polyfill = getPolyfill();
	define(Object, { entries: polyfill }, {
		entries: function testEntries() {
			return Object.entries !== polyfill;
		}
	});
	return polyfill;
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var config_1 = __webpack_require__(0);
var common_1 = __webpack_require__(3);
/**
 * Calculate the column widths
 */
function calculateWidths(doc, pageWidth) {
    var table = config_1.Config.tableInstance();
    // Column and table content width
    var fixedWidth = 0;
    var autoWidth = 0;
    var dynamicColumns = [];
    table.columns.forEach(function (column) {
        column.contentWidth = 0;
        table.rows.concat(table.headerRow).forEach(function (row) {
            var cell = row.cells[column.dataKey];
            cell.contentWidth = cell.padding('horizontal') + common_1.getStringWidth(cell.text, cell.styles);
            if (cell.contentWidth > column.contentWidth) {
                column.contentWidth = cell.contentWidth;
            }
        });
        table.contentWidth += column.contentWidth;
        if (typeof column.widthStyle === 'number') {
            column.preferredWidth = column.widthStyle;
            fixedWidth += column.preferredWidth;
            column.width = column.preferredWidth;
        }
        else if (column.widthStyle === 'wrap') {
            column.preferredWidth = column.contentWidth;
            fixedWidth += column.preferredWidth;
            column.width = column.preferredWidth;
        }
        else {
            column.preferredWidth = column.contentWidth;
            autoWidth += column.contentWidth;
            dynamicColumns.push(column);
        }
        table.preferredWidth += column.preferredWidth;
    });
    if (typeof table.settings.tableWidth === 'number') {
        table.width = table.settings.tableWidth;
    }
    else if (table.settings.tableWidth === 'wrap') {
        table.width = table.preferredWidth;
    }
    else {
        table.width = pageWidth - table.margin('left') - table.margin('right');
    }
    distributeWidth(dynamicColumns, fixedWidth, autoWidth, 0);
    // Row height, table height and text overflow
    var all = table.rows.concat(table.headerRow);
    all.forEach(function (row) {
        table.columns.forEach(function (col) {
            var cell = row.cells[col.dataKey];
            config_1.Config.applyStyles(cell.styles);
            var textSpace = col.width - cell.padding('horizontal');
            var k = config_1.Config.scaleFactor();
            if (cell.styles.overflow === 'linebreak') {
                // Add one pt to textSpace to fix rounding error
                try {
                    cell.text = doc.splitTextToSize(cell.text, textSpace + 1 / k, { fontSize: cell.styles.fontSize });
                }
                catch (e) {
                    if (e instanceof TypeError && Array.isArray(cell.text)) {
                        cell.text = doc.splitTextToSize(cell.text.join(' '), textSpace + 1 / k, { fontSize: cell.styles.fontSize });
                    }
                    else {
                        throw e;
                    }
                }
            }
            else if (cell.styles.overflow === 'ellipsize') {
                cell.text = common_1.ellipsize(cell.text, textSpace, cell.styles);
            }
            else if (cell.styles.overflow === 'visible') {
                // Do nothing
            }
            else if (cell.styles.overflow === 'hidden') {
                cell.text = common_1.ellipsize(cell.text, textSpace, cell.styles, '');
            }
            else if (typeof cell.styles.overflow === 'function') {
                cell.text = cell.styles.overflow(cell.text, textSpace);
            }
            else {
                console.error("Unrecognized overflow type: " + cell.styles.overflow);
            }
            var lineCount = Array.isArray(cell.text) ? cell.text.length : 1;
            var fontHeight = cell.styles.fontSize / k * config_1.FONT_ROW_RATIO;
            cell.contentHeight = lineCount * fontHeight + cell.padding('vertical');
            if (cell.contentHeight > row.height) {
                row.height = cell.contentHeight;
                row.maxLineCount = lineCount;
            }
        });
        table.height += row.height;
    });
}
exports.calculateWidths = calculateWidths;
function distributeWidth(dynamicColumns, staticWidth, dynamicColumnsContentWidth, fairWidth) {
    var table = config_1.Config.tableInstance();
    var extraWidth = table.width - staticWidth - dynamicColumnsContentWidth;
    for (var i = 0; i < dynamicColumns.length; i++) {
        var col = dynamicColumns[i];
        var ratio = col.contentWidth / dynamicColumnsContentWidth;
        // A column turned out to be none dynamic, start over recursively
        var isNoneDynamic = col.contentWidth + extraWidth * ratio < fairWidth;
        if (extraWidth < 0 && isNoneDynamic) {
            dynamicColumns.splice(i, 1);
            dynamicColumnsContentWidth -= col.contentWidth;
            col.width = fairWidth;
            staticWidth += col.width;
            distributeWidth(dynamicColumns, staticWidth, dynamicColumnsContentWidth, fairWidth);
            break;
        }
        else {
            col.width = col.contentWidth + extraWidth * ratio;
        }
    }
}


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var models_1 = __webpack_require__(4);
var config_1 = __webpack_require__(0);
var assign = __webpack_require__(5);
function validateInput(headers, data, allOptions) {
    if (!headers || typeof headers !== 'object') {
        console.error("The headers should be an object or array, is: " + typeof headers);
    }
    if (!data || typeof data !== 'object') {
        console.error("The data should be an object or array, is: " + typeof data);
    }
    var _loop_1 = function (settings) {
        if (settings && typeof settings !== 'object') {
            console.error("The options parameter should be of type object, is: " + typeof settings);
        }
        if (typeof settings.extendWidth !== 'undefined') {
            settings.tableWidth = settings.extendWidth ? 'auto' : 'wrap';
            console.error("Use of deprecated option: extendWidth, use tableWidth instead.");
        }
        if (typeof settings.margins !== 'undefined') {
            if (typeof settings.margin === 'undefined')
                settings.margin = settings.margins;
            console.error("Use of deprecated option: margins, use margin instead.");
        }
        if (typeof settings.afterPageContent !== 'undefined' || typeof settings.beforePageContent !== 'undefined' || typeof settings.afterPageAdd !== 'undefined') {
            console.error("The afterPageContent, beforePageContent and afterPageAdd hooks are deprecated. Use addPageContent instead");
            if (typeof settings.addPageContent === 'undefined') {
                settings.addPageContent = function (data) {
                    config_1.Config.applyUserStyles();
                    if (settings.beforePageContent)
                        settings.beforePageContent(data);
                    config_1.Config.applyUserStyles();
                    if (settings.afterPageContent)
                        settings.afterPageContent(data);
                    config_1.Config.applyUserStyles();
                    if (settings.afterPageAdd && data.pageCount > 1) {
                        data.afterPageAdd(data);
                    }
                    config_1.Config.applyUserStyles();
                };
            }
        }
        [['padding', 'cellPadding'], ['lineHeight', 'rowHeight'], 'fontSize', 'overflow'].forEach(function (o) {
            var deprecatedOption = typeof o === 'string' ? o : o[0];
            var style = typeof o === 'string' ? o : o[1];
            if (typeof settings[deprecatedOption] !== 'undefined') {
                if (typeof settings.styles[style] === 'undefined') {
                    settings.styles[style] = settings[deprecatedOption];
                }
                console.error("Use of deprecated option: " + deprecatedOption + ", use the style " + style + " instead.");
            }
        });
        for (var _i = 0, _a = ['styles', 'bodyStyles', 'headerStyles', 'columnStyles']; _i < _a.length; _i++) {
            var styleProp = _a[_i];
            if (settings[styleProp] && typeof settings[styleProp] !== 'object') {
                console.error("The " + styleProp + " style should be of type object, is: " + typeof settings[styleProp]);
            }
            else if (settings[styleProp] && settings[styleProp].rowHeight) {
                console.error("Use of deprecated style: rowHeight, use vertical cell padding instead");
            }
        }
    };
    for (var _i = 0, allOptions_1 = allOptions; _i < allOptions_1.length; _i++) {
        var settings = allOptions_1[_i];
        _loop_1(settings);
    }
}
exports.validateInput = validateInput;
/**
 * Create models from the user input
 *
 * @param inputHeaders
 * @param inputData
 */
function createModels(inputHeaders, inputData) {
    var splitRegex = /\r\n|\r|\n/g;
    var table = config_1.Config.tableInstance();
    var settings = table.settings;
    var theme = config_1.getTheme(settings.theme);
    // Header row and columns
    var headerRow = new models_1.Row(inputHeaders, -1);
    headerRow.index = -1;
    // Columns and header row
    inputHeaders.forEach(function (rawColumn, index) {
        var dataKey = index;
        if (typeof rawColumn.dataKey !== 'undefined') {
            dataKey = rawColumn.dataKey;
        }
        else if (typeof rawColumn.key !== 'undefined') {
            console.error("Deprecation warning: Use dataKey instead of key");
            dataKey = rawColumn.key; // deprecated since 2.x
        }
        var col = new models_1.Column(dataKey, index);
        col.raw = rawColumn;
        col.widthStyle = config_1.Config.styles([theme.table, theme.header, table.styles.styles, table.styles.columnStyles[col.dataKey] || {}]).columnWidth;
        table.columns.push(col);
        var cell = new models_1.Cell(rawColumn);
        cell.styles = config_1.Config.styles([theme.table, theme.header, table.styles.styles, table.styles.headerStyles]);
        if (cell.raw instanceof HTMLElement) {
            cell.text = (cell.raw.innerText || '').trim();
        }
        else {
            var text = typeof cell.raw === 'object' ? cell.raw.title : cell.raw;
            // Stringify 0 and false, but not undefined
            cell.text = typeof cell.raw !== 'undefined' ? '' + text : '';
        }
        cell.text = cell.text.split(splitRegex);
        headerRow.cells[dataKey] = cell;
        for (var _i = 0, _a = table.hooks.createdHeaderCell; _i < _a.length; _i++) {
            var hook = _a[_i];
            hook(cell, { cell: cell, column: col, row: headerRow, settings: settings });
        }
    });
    table.headerRow = headerRow;
    // Rows och cells
    inputData.forEach(function (rawRow, i) {
        var row = new models_1.Row(rawRow, i);
        var rowStyles = i % 2 === 0 ? assign({}, theme.alternateRow, table.styles.alternateRowStyles) : {};
        table.columns.forEach(function (column) {
            var cell = new models_1.Cell(rawRow[column.dataKey]);
            var colStyles = table.styles.columnStyles[column.dataKey] || {};
            cell.styles = config_1.Config.styles([theme.table, theme.body, table.styles.styles, table.styles.bodyStyles, rowStyles, colStyles]);
            if (cell.raw && cell.raw instanceof HTMLElement) {
                cell.text = (cell.raw.innerText || '').trim();
            }
            else {
                // Stringify 0 and false, but not undefined
                cell.text = typeof cell.raw !== 'undefined' ? '' + cell.raw : '';
            }
            cell.text = cell.text.split(splitRegex);
            row.cells[column.dataKey] = cell;
            for (var _i = 0, _a = table.hooks.createdCell; _i < _a.length; _i++) {
                var hook = _a[_i];
                hook(cell, config_1.Config.hooksData({ cell: cell, column: column, row: row }));
            }
        });
        table.rows.push(row);
    });
}
exports.createModels = createModels;


/***/ })
/******/ ]);
});

/***/ }),

/***/ 718:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [(_vm.$vuetify.breakpoint.smAndUp) ? _c('span', {
    staticClass: "caption"
  }, [_vm._v("Download as ")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "caption",
    staticStyle: {
      "min-width": "0"
    },
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.download('PDF')
      }
    }
  }, [_vm._v("PDF")]), _vm._v(" "), _c('v-btn', {
    staticClass: "caption",
    staticStyle: {
      "min-width": "0"
    },
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.download('CSV')
      }
    }
  }, [_vm._v("CSV")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 719:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(720), __esModule: true };

/***/ }),

/***/ 720:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(359);
__webpack_require__(722);
module.exports = __webpack_require__(31).Array.from;


/***/ }),

/***/ 721:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(71);
var createDesc = __webpack_require__(147);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),

/***/ 722:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(70);
var $export = __webpack_require__(55);
var toObject = __webpack_require__(146);
var call = __webpack_require__(356);
var isArrayIter = __webpack_require__(355);
var toLength = __webpack_require__(148);
var createProperty = __webpack_require__(721);
var getIterFn = __webpack_require__(358);

$export($export.S + $export.F * !__webpack_require__(357)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),

/***/ 730:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_app_cfg__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__config_app_cfg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_handy__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_handy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__utils_handy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__VDownloadAs_vue__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__VDownloadAs_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__VDownloadAs_vue__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'v-download-as': __WEBPACK_IMPORTED_MODULE_5__VDownloadAs_vue___default.a
  },
  data: function data() {
    return {
      // minrules: [v => v.length >= 5 || 'Min 5 characters'],
      // common
      lAction: 'view',
      sbar: false,
      sbarCol: 'error',
      sbarMsg: '',
      load: false,
      handy: __WEBPACK_IMPORTED_MODULE_4__utils_handy___default.a,
      config: __WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a,
      rules: __WEBPACK_IMPORTED_MODULE_4__utils_handy___default.a.rules,
      beingSaved: false,
      pageRefKey: 0, // used to refresh page
      // component specific
      tab: 'tab-0',
      attTab: 'tab-0',
      tabitems: ['attendance', 'reports'],
      attTabItems: ['today', 'yesterday', 'week', 'month/period'],
      shifts: [],
      vendors: [],
      summary: [],
      shiftSummary: {},
      keyStaffs: [],
      attLog: [],
      attDet: [],
      lAttDet: '',
      lCurrentShiftId: '',
      lCurrentShift: '',
      lCurrentFrom: '',
      lCurrentTo: '',
      search: '',
      attHead: [{ text: 'Role', value: 'staff_role', class: 'pa-3' }, { text: 'Name', value: 'staff_name', class: 'pa-3' }, { text: 'Attendance', value: 'attendance', class: 'pa-3' }],
      attHeadSm: [{ text: 'Date', value: 'att_dt', class: 'pa-3' }, { text: 'Role', value: 'staff_role', class: 'pa-3' }, { text: 'Name', value: 'staff_name', class: 'pa-3' }, { text: 'Attendance', value: 'attendance', class: 'pa-3' }, { text: 'Standby', value: 'standby', class: 'pa-3' }, { text: 'Check-in', value: 'check_in', class: 'pa-3' }, { text: 'Check-out', value: 'check_out', class: 'pa-3' }, { text: 'Working-hours', value: 'effective_work_hours', class: 'pa-3' }, { text: 'Reason', value: 'remark' }, { text: 'Approved By', value: 'approved_by' }],
      keyStaffHead: [{ text: 'Role', value: 'staff_role', class: 'pa-3' }, { text: 'Name', value: 'staff_name', class: 'pa-3' }, { text: 'Mobile', value: 'staff_mobile', class: 'pa-3' }, { text: 'Attendance', value: 'attendance', class: 'pa-3' }],
      keyStaffHeadSm: [{ text: 'Date', value: 'att_dt', class: 'pa-3' }, { text: 'Role', value: 'staff_role', class: 'pa-3' }, { text: 'Name', value: 'staff_name', class: 'pa-3' }, { text: 'Mobile', value: 'staff_mobile', class: 'pa-3' }, { text: 'Attendance', value: 'attendance', class: 'pa-3' }, { text: 'Standby', value: 'standby', class: 'pa-3' }, { text: 'Check-in', value: 'check_in', class: 'pa-3' }, { text: 'Check-out', value: 'check_out', class: 'pa-3' }],
      attLogHead: [{ text: 'In/Out', value: 'log_action', width: '30px' }, { text: 'Time', value: 'log_time', width: '150px' }, { text: 'Name', value: 'staff_name', width: '200px' }],
      attLogHeadSm: [{ text: 'In/Out', value: 'log_action' }, { text: 'At', value: 'log_mode_and_loc' }, { text: 'Time', value: 'log_time' }, { text: 'Name', value: 'staff_name' }, { text: 'Role', value: 'staff_role' }, { text: 'Reason', value: 'remark' }, { text: 'Approved By', value: 'approved_by' }],
      offlineDevHead: [{ text: 'Name', value: 'staff_name', width: '100px' }, { text: 'Deviation', value: 'offline_deviation', width: '200px' }],
      offlineDevHeadSm: [{ text: 'In/Out', value: 'log_action' }, { text: 'At', value: 'log_mode_and_loc' }, { text: 'Time', value: 'log_time' }, { text: 'Name', value: 'staff_name' }, { text: 'Deviation', value: 'offline_deviation', width: '375px' }],
      dlgAttDet: false,
      dlgAttLog: false,
      dlgPeriodFrom: false,
      dlgPeriodTo: false,
      dlgCheckIn: false,
      dlgCheckInTime: false,
      dlgCheckOut: false,
      dlgCheckOutTime: false,
      // report
      filter: '',
      roles: [],
      dlgFromDt: '',
      dlgToDt: '',
      attReport: [],
      agreedDays: [],
      attReportDet: [],
      repHead: [{ text: 'Role', value: 'staff_role', class: 'pa-2' }, { text: 'Agreement', value: 'tot_contracted', class: 'accent white--text pa-2 text-xs-center' }, { text: 'Billable', value: 'tot_billable', class: 'success white--text pa-2 text-xs-center' }],
      repHeadSm: [{ text: 'Role [Headcount]', value: 'staff_role', class: 'pa-2' }, { text: 'Present [a]', value: 'tot_present', class: 'green--text pa-2 text-xs-center', align: 'right' }, { text: 'Weekoff [b]', value: 'tot_wo', class: 'green--text pa-2 text-xs-center', align: 'right' }, { text: 'Holiday [c]', value: 'tot_holiday', class: 'green--text pa-2 text-xs-center', align: 'right' }, { text: 'Standby/OT [d]', value: 'tot_ot', class: 'green--text pa-2 text-xs-center', align: 'right' }, { text: 'Leave [e]', value: 'tot_leave', class: 'green--text pa-2 text-xs-center', align: 'right' }, { text: 'Absent', value: 'tot_absent', class: 'red--text pa-2 text-xs-center', align: 'right' }, { text: 'Agreement', value: 'tot_contracted', class: 'accent white--text pa-2 text-xs-center', align: 'right' }, { text: 'Billable [a+b+c+d+e]', value: 'tot_billable', class: 'success white--text pa-2 text-xs-center', align: 'right' }],
      repHeadCountSm: [{ text: 'Role [Agreed HC]', value: 'staff_role', class: 'pa-2' }, { text: 'Present [a]', value: 'tot_present', class: 'green--text pa-2 text-xs-center', align: 'right' }, { text: 'Weekoff [b]', value: 'tot_wo', class: 'green--text pa-2 text-xs-center', align: 'right' }, { text: 'Holiday [c]', value: 'tot_holiday', class: 'green--text pa-2 text-xs-center', align: 'right' }, { text: 'Standby/OT [d]', value: 'tot_ot', class: 'green--text pa-2 text-xs-center', align: 'right' }, { text: 'Leave [e]', value: 'tot_leave', class: 'green--text pa-2 text-xs-center', align: 'right' }, { text: 'Absent', value: 'tot_absent', class: 'red--text pa-2 text-xs-center', align: 'right' }, { text: 'Agreement', value: 'tot_contracted', class: 'accent white--text pa-2 text-xs-center', align: 'right' }, { text: 'Billable [a+b+c+d+e]', value: 'tot_billable', class: 'success white--text pa-2 text-xs-center', align: 'right' }],
      repDetCalHeadSm: [], // constructed dynamically
      repDetStaffHead: [{ text: 'Staff', value: 'staff_name', class: 'pa-2' }, { text: 'Agreement', value: 'tot_contracted', class: 'accent white--text pa-2 text-xs-center' }, { text: 'Billable', value: 'tot_billable', class: 'success white--text pa-2 text-xs-center' }],
      repDetStaffHeadSm: [{ text: 'Role', value: 'staff_role', class: 'pa-2' }, { text: 'Staff', value: 'staff_name', class: 'pa-2' }, { text: 'Emp ID', value: 'vendor_emp_id', class: 'pa-2', align: 'center' }, { text: 'Present [a]', value: 'tot_present', class: 'green--text pa-2 text-xs-center', align: 'right' }, { text: 'Weekoff [b]', value: 'tot_wo', class: 'green--text pa-2 text-xs-center', align: 'right' }, { text: 'Holiday [c]', value: 'tot_holiday', class: 'green--text pa-2 text-xs-center', align: 'right' }, { text: 'Standby/OT [d]', value: 'tot_ot', class: 'green--text pa-2 text-xs-center', align: 'right' }, { text: 'Leave [e]', value: 'tot_leave', class: 'green--text pa-2 text-xs-center', align: 'right' }, { text: 'Absent', value: 'tot_absent', class: 'red--text pa-2 text-xs-center', align: 'right' }, { text: 'Agreement', value: 'tot_contracted', class: 'accent white--text pa-2 text-xs-center', align: 'right' }, { text: 'Billable [a+b+c+d+e]', value: 'tot_billable', class: 'success white--text pa-2 text-xs-center', align: 'right' }],
      vendorStandby: [],
      tempStandby: '',
      shiftNotRight: false,
      shiftOverride: false,
      filterOfflineDev: false,
      offlineDevList: [],
      attNonBill: {},
      billableChip: ['Billable', 'Non-billable'],
      nonBillshiftSummary: {},
      lRep: {
        agreedHeadCount: false
      },
      enableChip: '',
      att_dev_type: ''
    };
  },
  created: function created() {
    var _this = this;

    this.loadShift();
    this.loadVendor();
    this.loadVendorEmp().then(function (res) {
      _this.refreshTab('attendance');
    });
  },
  mounted: function mounted() {
    this.$forceUpdate();
    this.loadAttDevType();
  },

  methods: {
    msg: function msg(m) {
      var isError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      this.sbarCol = isError ? 'error' : 'success';
      this.sbar = true;
      this.sbarMsg = m;
    },
    loading: function loading() {
      this.load = true;
    },
    showShift: function showShift(curShiftId) {
      var _this2 = this;

      // change to chosen shift
      this.lCurrentShiftId = curShiftId;
      this.lCurrentShift = this.shifts.find(function (rec) {
        return rec.shift_id === curShiftId;
      }).shift_abbr;
      if (this.shiftSummary[curShiftId].detail && this.shiftSummary[curShiftId].detail.length > 0) {
        this.keyStaffs = this.shiftSummary[curShiftId].detail.filter(function (rec) {
          return rec.staff_role.includes('Helpdesk') || rec.staff_role.includes('Facility') || rec.staff_role.includes('Supervisor') || rec.staff_role.includes('Manager') || rec.staff_role.includes('Electrician') || rec.staff_role.includes('Plumber') || rec.staff_role.includes('Multi');
        });
        this.keyStaffs.forEach(function (rec) {
          if (rec.sby_vendor_emp_id) {
            rec.standby = _this2.vendorStandby.find(function (emp) {
              return emp.vendor_emp_id === rec.sby_vendor_emp_id;
            }).emp_name_and_id;
          } else if (rec.sby_temp_staff_name) {
            rec.standby = rec.sby_temp_staff_name;
          }
        });
      }
    },
    showShiftDet: function showShiftDet(curShiftId) {
      this.lCurrentShiftId = curShiftId;
      this.lAction = 'att-det';
      this.loadNonBillableStaffs(curShiftId);
      this.refreshNonBillAttReportDet(this.filter.billable);
    },
    showAttLog: function showAttLog() {
      var _this3 = this;

      // load log
      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a.COMM_ID,
          from_dt: this.lCurrentFrom,
          to_dt: this.lCurrentTo,
          vendor_list: this.filter.vendor_list.map(function (rec) {
            return rec.vendor_id;
          })
        }
      };
      this.attLog = [];
      this.offlineDevList = [];
      this.axios.get(__WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a.API_URL + '/getAttendanceLogByCommId/', qry).then(function (response) {
        _this3.attLog = response.data;
        _this3.offlineDevList = response.data.filter(function (rec) {
          return rec.offline_deviation;
        });
      }).catch(function (err) {
        _this3.msg(err.response.data, true);
      });
      this.lAction = 'att-log';
    },
    prepareEditDet: function prepareEditDet(curDet) {
      var _this4 = this;

      this.lAttDet = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, curDet);
      this.shiftNotRight = false;
      this.shiftOverride = false;
      if (!this.lAttDet.attendance) {
        this.lAttDet.attendance = '';
      }
      if (this.lAttDet.sby_vendor_emp_id) {
        this.lAttDet.sby_vendor_emp_pair = { vendor_emp_id: this.lAttDet.sby_vendor_emp_id, emp_name_and_id: this.vendorStandby.find(function (rec) {
            return rec.vendor_emp_id === _this4.lAttDet.sby_vendor_emp_id;
          }).emp_name_and_id };
      }
      if (this.lAttDet.check_in) {
        this.lAttDet.checkInDt = __WEBPACK_IMPORTED_MODULE_4__utils_handy___default.a.formatDBDate(new Date(this.lAttDet.check_in));
        this.lAttDet.checkInTime = __WEBPACK_IMPORTED_MODULE_4__utils_handy___default.a.getTime(new Date(this.lAttDet.check_in));
        this.lAttDet.prevCheckInDt = this.lAttDet.checkInDt;
        this.lAttDet.prevCheckInTime = this.lAttDet.checkInTime;
      } else {
        this.lAttDet.checkInDt = this.lAttDet.att_dt;
      }
      if (this.lAttDet.check_out) {
        this.lAttDet.checkOutDt = __WEBPACK_IMPORTED_MODULE_4__utils_handy___default.a.formatDBDate(new Date(this.lAttDet.check_out));
        this.lAttDet.checkOutTime = __WEBPACK_IMPORTED_MODULE_4__utils_handy___default.a.getTime(new Date(this.lAttDet.check_out));
        this.lAttDet.prevCheckOutDt = this.lAttDet.checkOutDt;
        this.lAttDet.prevCheckOutTime = this.lAttDet.checkOutTime;
      } else {
        this.lAttDet.checkOutDt = this.lAttDet.checkInDt;
      }
      this.lAttDet.checkInMinDt = new Date(this.lAttDet.att_dt);
      this.lAttDet.checkInMinDt.setDate(this.lAttDet.checkInMinDt.getDate() - 1);
      this.lAttDet.checkInMaxDt = this.lAttDet.att_dt;
      this.lAttDet.checkOutMaxDt = new Date(this.lAttDet.att_dt);
      this.lAttDet.checkOutMaxDt.setDate(this.lAttDet.checkOutMaxDt.getDate() + 1);
      this.dlgAttDet = true;
    },
    GetCheckOutDate: function GetCheckOutDate(curCheckInDate) {
      // this.lAttDet.checkOutDt = curCheckInDate
      var tmpDt = new Date(curCheckInDate);
      this.lAttDet.checkOutMaxDt.setDate(tmpDt.getDate() + 1);
    },
    saveChanges: function saveChanges() {
      var _this5 = this;

      // validate and save Changes
      if (!this.$refs.lForm.validate()) {
        return;
      }
      if (this.lAttDet.attendance !== '' && this.lAttDet.attendance !== 'Absent' && this.lAttDet.attendance !== 'Comp Off' && this.lAttDet.attendance !== 'Holiday' && this.lAttDet.attendance !== 'Weekly Off' && !this.lAttDet.attendance.includes('Leave') || this.lAttDet.sby_vendor_emp_pair || this.lAttDet.sby_temp_staff_name) {
        if (!this.lAttDet.checkInDt || !this.lAttDet.checkInTime) {
          this.msg('Choose check-in date and time', true);
          return;
        }
        if (this.lAttDet.checkInDt === this.lAttDet.checkOutDt && this.lAttDet.checkInTime > this.lAttDet.checkOutTime) {
          this.msg('Check-out time should be greater than check-in time', true);
          return;
        }
        // ensure check-in time is with in shift window
        var chosenShift = this.shifts.find(function (rec) {
          return rec.shift_id === _this5.lAttDet.shift_id;
        });
        var tmpShiftStart = new Date(this.lAttDet.att_dt + ' ' + chosenShift.start_time);
        var tmpCheckIn = new Date(this.lAttDet.checkInDt + ' ' + this.lAttDet.checkInTime);
        var hoursDiff = (tmpCheckIn - tmpShiftStart) / 1000 / 60 / 60;
        if (Math.abs(hoursDiff) > __WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a.ATTENDANCE_SHIFT_THRESHOLD && !this.shiftOverride) {
          this.shiftNotRight = true;
          return;
        }
      } else {
        this.lAttDet.checkInDt = null;
        this.lAttDet.checkInTime = null;
        this.lAttDet.checkOutDt = null;
        this.lAttDet.checkOutTime = null;
      }
      if (this.lAttDet.sby_vendor_emp_pair && this.lAttDet.sby_temp_staff_name) {
        this.msg('Both standby and temporary staff are not allowed at same time', true);
        return;
      }

      var action = '';
      if (this.lAttDet.att_id) {
        action = 'update';
      } else {
        action = 'create';
      }

      this.beingSaved = true;
      // preprocessing
      this.lAttDet.comm_id = __WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a.COMM_ID;
      this.lAttDet.detail = [];
      // record manual attendance if check-in/out times changed
      if (this.lAttDet.checkInDt && this.lAttDet.checkInTime && (this.lAttDet.checkInDt !== this.lAttDet.prevCheckInDt || this.lAttDet.checkInTime !== this.lAttDet.prevCheckInTime)) {
        this.lAttDet.detail.push({
          log_dt: __WEBPACK_IMPORTED_MODULE_4__utils_handy___default.a.formatDBDateTime(new Date(this.lAttDet.checkInDt + ' ' + this.lAttDet.checkInTime)),
          log_action: 'IN',
          log_mode: 'Manual'
        });
      }
      if (this.lAttDet.checkOutDt && this.lAttDet.checkOutTime && (this.lAttDet.checkOutDt !== this.lAttDet.prevCheckOutDt || this.lAttDet.checkOutTime !== this.lAttDet.prevCheckOutTime)) {
        this.lAttDet.detail.push({
          log_dt: __WEBPACK_IMPORTED_MODULE_4__utils_handy___default.a.formatDBDateTime(new Date(this.lAttDet.checkOutDt + ' ' + this.lAttDet.checkOutTime)),
          log_action: 'OUT',
          log_mode: 'Manual'
        });
      }

      // preprocessing
      if (this.lAttDet.attendance === 'Absent' || this.lAttDet.attendance && this.lAttDet.attendance.includes('Leave') || this.lAttDet.attendance === 'Weekly Off' || this.lAttDet.attendance === 'Holiday') {
        if (this.lAttDet.sby_vendor_emp_pair) {
          this.lAttDet.sby_vendor_emp_id = this.lAttDet.sby_vendor_emp_pair.vendor_emp_id;
        } else {
          this.lAttDet.sby_vendor_emp_id = null;
        }
      } else {
        // void the stand-by details in case entered accidentally
        this.lAttDet.sby_vendor_emp_id = null;
        this.lAttDet.sby_temp_staff_name = null;
      }

      this.axios.post(__WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a.API_URL + '/attendance/' + action, this.lAttDet).then(function (response) {
        // refresh list in front end
        setTimeout(function () {
          if (_this5.filter.billable === 'Billable') {
            _this5.loadAttSummary(_this5.filter.current_period, _this5.filter.billable);
          } else {
            _this5.refreshNonBillAttReportDet('Non-billable');
          }
          _this5.beingSaved = false;
          _this5.dlgAttDet = false;
        }, 500);
      }).catch(function (err) {
        _this5.msg(err.response.data, true);
        _this5.beingSaved = false;
      });
    },
    loadShift: function loadShift() {
      var _this6 = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a.COMM_ID
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a.API_URL + '/getShiftsByCommId/', qry).then(function (response) {
        _this6.shifts = response.data;
        _this6.lCurrentShiftId = _this6.shifts[0].shift_id; // default shift
        // hightlight shift based on current system time
        var curTime = __WEBPACK_IMPORTED_MODULE_4__utils_handy___default.a.getTime(new Date());
        _this6.shifts.forEach(function (rec) {
          _this6.shiftSummary[rec.shift_id] = []; // initialize for later use
          if (curTime >= rec.start_time && curTime <= rec.end_time) {
            _this6.lCurrentShiftId = rec.shift_id;
            _this6.lCurrentShift = rec.shift_abbr;
          }
        });
      }).catch(function (err) {
        _this6.msg(err.response.data, true);
        _this6.shifts = [];
      });
    },
    loadVendor: function loadVendor() {
      var _this7 = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a.COMM_ID
        }
      };
      this.vendors = [];
      this.axios.get(__WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a.API_URL + '/getVendorWithStaffByCommId/', qry).then(function (response) {
        _this7.vendors = response.data;
      }).catch(function (err) {
        _this7.msg(err.response.data, true);
      });
    },
    loadAttSummary: function loadAttSummary() {
      var _this8 = this;

      var period = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'month/period';
      var curChip = arguments[1];

      this.filter.billable = curChip;
      // load attendance summary for given period
      this.filter.current_period = period;
      var curDate = new Date();
      if (period === 'today') {
        this.lCurrentFrom = curDate;
        this.lCurrentTo = this.lCurrentFrom;
      } else if (period === 'yesterday') {
        this.lCurrentFrom = curDate.setDate(curDate.getDate() - 1);
        this.lCurrentTo = this.lCurrentFrom;
      } else if (period === 'week') {
        this.lCurrentFrom = curDate.setDate(curDate.getDate() - (curDate.getDay() + 6) % 7);
        this.lCurrentTo = new Date();
      } else if (period === 'month/period') {
        this.lCurrentFrom = this.filter.from_dt;
        this.lCurrentTo = this.filter.to_dt;
      }
      this.lCurrentFrom = __WEBPACK_IMPORTED_MODULE_4__utils_handy___default.a.formatDBDate(this.lCurrentFrom);
      this.lCurrentTo = __WEBPACK_IMPORTED_MODULE_4__utils_handy___default.a.formatDBDate(this.lCurrentTo);
      curDate = this.handy.formatDBDate(curDate);
      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a.COMM_ID,
          from_dt: this.lCurrentFrom,
          to_dt: this.lCurrentTo,
          vendor_list: this.filter.vendor_list.map(function (rec) {
            return rec.vendor_id;
          }),
          is_billable: curChip === 'Billable' ? 1 : 0
        }
      };
      this.shifts.forEach(function (rec) {
        _this8.shiftSummary[rec.shift_id] = [];
      });
      this.axios.get(__WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a.API_URL + '/getAttendanceByCommId/', qry).then(function (response) {
        _this8.summary = response.data;
        // filter for each shift
        _this8.shifts.forEach(function (rec) {
          _this8.shiftSummary[rec.shift_id].start_time = rec.start_time;
          _this8.shiftSummary[rec.shift_id].end_time = rec.end_time;
          _this8.shiftSummary[rec.shift_id].detail = _this8.summary.filter(function (att) {
            return att.shift_id === rec.shift_id;
          });
          _this8.shiftSummary[rec.shift_id].detail.forEach(function (rec) {
            if (rec.sby_vendor_emp_id) {
              rec.standby = _this8.vendorStandby.find(function (emp) {
                return emp.vendor_emp_id === rec.sby_vendor_emp_id;
              }).emp_name_and_id;
            } else if (rec.sby_temp_staff_name) {
              rec.standby = rec.sby_temp_staff_name;
            }
          });
          _this8.shiftSummary[rec.shift_id].totStaff = _this8.shiftSummary[rec.shift_id].detail.length;
          _this8.shiftSummary[rec.shift_id].totPresent = _this8.shiftSummary[rec.shift_id].detail.filter(function (att) {
            return att.attendance && att.attendance.includes('Present');
          }).length;
          _this8.shiftSummary[rec.shift_id].totAbsent = _this8.shiftSummary[rec.shift_id].detail.filter(function (att) {
            return att.attendance === 'Absent';
          }).length;
          _this8.shiftSummary[rec.shift_id].totLeave = _this8.shiftSummary[rec.shift_id].detail.filter(function (att) {
            return att.attendance && att.attendance.includes('Leave', 'Comp Off');
          }).length;
          _this8.shiftSummary[rec.shift_id].totWO = _this8.shiftSummary[rec.shift_id].detail.filter(function (att) {
            return att.attendance && att.attendance.includes('Weekly Off');
          }).length;
          _this8.shiftSummary[rec.shift_id].totHol = _this8.shiftSummary[rec.shift_id].detail.filter(function (att) {
            return att.attendance && att.attendance.includes('Holiday');
          }).length;
          _this8.shiftSummary[rec.shift_id].totOT = _this8.shiftSummary[rec.shift_id].detail.filter(function (att) {
            return att.attendance && (att.attendance.includes('OT') || att.standby);
          }).length;
          _this8.shiftSummary[rec.shift_id].totNotYetIn = _this8.shiftSummary[rec.shift_id].detail.filter(function (att) {
            return !att.attendance;
          }).length;
          _this8.shiftSummary[rec.shift_id].totNotYetOut = _this8.shiftSummary[rec.shift_id].detail.filter(function (att) {
            return (att.attendance !== 'Absent' && att.attendance !== 'Weekly Off' && att.attendance !== 'Holiday' || att.standby || att.sby_temp_staff_name) && att.check_in && !att.check_out;
          }).length;
          // adjust half days
          _this8.shiftSummary[rec.shift_id].totHD = _this8.shiftSummary[rec.shift_id].detail.filter(function (att) {
            return att.attendance === 'Half Day';
          }).length;
          _this8.shiftSummary[rec.shift_id].totPresent = _this8.shiftSummary[rec.shift_id].totPresent + _this8.shiftSummary[rec.shift_id].totHD / 2;
          _this8.shiftSummary[rec.shift_id].totAbsent = _this8.shiftSummary[rec.shift_id].totAbsent + _this8.shiftSummary[rec.shift_id].totHD / 2;
          _this8.shiftSummary[rec.shift_id].attAve = Math.round((_this8.shiftSummary[rec.shift_id].totPresent + _this8.shiftSummary[rec.shift_id].totOT + _this8.shiftSummary[rec.shift_id].totWO + _this8.shiftSummary[rec.shift_id].totHol) / _this8.shiftSummary[rec.shift_id].totStaff * 100);
        });
        _this8.showShift(_this8.lCurrentShiftId);
        _this8.$forceUpdate();
      }).catch(function (err) {
        _this8.summary = {};
        _this8.msg(err.response.data, true);
      });
    },
    loadVendorEmp: function loadVendorEmp() {
      var _this9 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var qry = {
          params: {
            vendor_id: __WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a.IS_BB_VENDOR ? __WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a.FM_VENDOR_ID : ''
          }
        };
        _this9.vendorStandby = [];
        _this9.axios.get(__WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a.API_URL + '/getEmpByVendorId/', qry).then(function (response) {
          _this9.vendorStandby = response.data;
          resolve(true);
        }).catch(function (err) {
          _this9.msg(err.response.data, true);
          resolve(true);
        });
      });
    },
    refreshAttReport: function refreshAttReport() {
      var _this10 = this;

      var isAgreed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var curChip = arguments[1];

      this.enableChip = curChip;
      this.loading();
      // number of reporting days
      var oneDay = 24 * 60 * 60 * 1000;
      var fromDt = new Date(this.filter.from_dt);
      var toDt = new Date(this.filter.to_dt);
      this.filter.rep_days = Math.abs(Math.round(toDt.getTime() - fromDt.getTime())) / oneDay + 1;
      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a.COMM_ID,
          from_dt: this.filter.from_dt,
          to_dt: this.filter.to_dt,
          vendor_list: this.filter.vendor_list.map(function (rec) {
            return rec.vendor_id;
          }),
          role_list: this.filter.role_list.map(function (rec) {
            return rec.staff_role_id;
          }),
          group_by: 'role',
          is_billable: this.enableChip === 'Billable' ? 1 : 0,
          is_agreed: isAgreed,
          vendor_id: __WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a.FM_VENDOR_ID
        }
      };
      this.attReport = [];
      this.attReportDet = [];
      this.axios.get(__WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a.API_URL + '/getAttendanceRep/', qry).then(function (response) {
        _this10.attReport = response.data;
        _this10.axios.get(__WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a.API_URL + '/getAttendanceAgreedDays/', qry).then(function (res) {
          _this10.agreedDays = res.data;
          // calculate few fields
          var idx = -1;
          if (!isAgreed) {
            _this10.attReport.forEach(function (rec) {
              if (rec.is_part_time) {
                rec.tot_contracted = Number(rec.agreed_head_count) * Number(rec.agreed_days);
              } else {
                idx = _this10.agreedDays.findIndex(function (agr) {
                  return agr.staff_role === rec.staff_role;
                });
                if (idx >= 0) {
                  rec.tot_contracted = _this10.agreedDays[idx].agreed_days;
                } else {
                  rec.tot_contracted = 0;
                }
              }
              rec.staff_role = rec.staff_role + ' [' + rec.role_count + (rec.tot_contracted < rec.role_count * _this10.filter.rep_days ? '*' : '') + ']';
              rec.tot_present = rec.tot_present + rec.tot_hd / 2;
              rec.tot_absent = rec.tot_absent + rec.tot_hd / 2;
              rec.tot_billable = rec.tot_present + rec.tot_wo + rec.tot_holiday + rec.tot_ot + rec.tot_leave;
            });
          } else {
            _this10.attReport.forEach(function (rec) {
              if (rec.is_part_time) {
                rec.tot_contracted = Number(rec.agreed_head_count) * Number(rec.agreed_days);
              } else {
                idx = _this10.agreedDays.findIndex(function (agr) {
                  return agr.staff_role === rec.staff_role;
                });
                if (idx >= 0) {
                  rec.tot_contracted = _this10.agreedDays[idx].tot_contracted;
                } else {
                  rec.tot_contracted = 0;
                }
              }
              rec.staff_role = rec.staff_role + ' [' + rec.agreed_head_count + ']';
              rec.tot_present = rec.tot_present + rec.tot_hd / 2;
              rec.tot_absent = rec.tot_absent + rec.tot_hd / 2;
              rec.tot_billable = rec.tot_present + rec.tot_wo + rec.tot_holiday + rec.tot_ot + rec.tot_leave;
            });
          }
          _this10.load = false;
          // attendance detail
          _this10.refreshAttReportDet(_this10.filter.billable);
        });
      }).catch(function (err) {
        _this10.msg(err.response.data, true);
        _this10.load = false;
      });
    },
    refreshAttReportDet: function refreshAttReportDet(curChip) {
      var _this11 = this;

      this.filter.billable = curChip;
      this.loading();
      // construct detail based on view chosen by user
      this.attReportDet = [];
      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a.COMM_ID,
          from_dt: this.filter.from_dt,
          to_dt: this.filter.to_dt,
          vendor_list: this.filter.vendor_list.map(function (rec) {
            return rec.vendor_id;
          }),
          role_list: this.filter.role_list.map(function (rec) {
            return rec.staff_role_id;
          }),
          order_by: 'date', // used if the api is getAttendanceByCommId
          is_billable: this.filter.billable === 'Billable' ? 1 : 0
        }
      };
      var apiName = this.filter.det_type === 'staff' ? 'getAttendanceRep' : this.filter.det_type === 'inOutSheet' ? 'getAttendanceInOutTimeRep' : 'getAttendanceByCommId';
      this.axios.get(__WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a.API_URL + '/' + apiName + '/', qry).then(function (response) {
        // calculate few fields
        if (_this11.filter.det_type === 'date' || _this11.filter.det_type === 'timesheet' || _this11.filter.det_type === 'inOutSheet') {
          // construct calendar view from retrived data for every staff
          var tmpStaffId = -1;
          var idx = -1;
          var dtIdx = 3;
          var addedDates = [];
          var tmpDt = '';
          var curAtt = '';
          var curDet = '';
          var sbyList = [];
          _this11.repDetCalHeadSm = [{ text: 'Role', value: 'staff_role', class: 'pa-2', columnWidth: _this11.filter.det_type === 'timesheet' ? 14 : 20 }, { text: 'Staff', value: 'staff_name', class: 'pa-2', columnWidth: _this11.filter.det_type === 'timesheet' ? 18 : 30 }, { text: 'Emp ID', value: 'vendor_emp_id', class: 'pa-2 text-xs-center', align: 'center', columnWidth: 10 },
          /* attendance for every calendar day added dynamically */
          { text: 'P', value: 'tot_present', class: 'green--text pa-2 text-xs-center', align: 'right', columnWidth: _this11.filter.det_type === 'timesheet' ? 6 : 7 }, { text: 'W', value: 'tot_wo', class: 'green--text pa-2 text-xs-center', align: 'right', columnWidth: _this11.filter.det_type === 'timesheet' ? 6 : 7 }, { text: 'H', value: 'tot_holiday', class: 'green--text pa-2 text-xs-center', align: 'right', columnWidth: _this11.filter.det_type === 'timesheet' ? 6 : 7 }, { text: 'S/O', value: 'tot_ot', class: 'green--text pa-2 text-xs-center', align: 'right', columnWidth: _this11.filter.det_type === 'timesheet' ? 6 : 7 }, { text: 'L', value: 'tot_leave', class: 'green--text pa-2 text-xs-center', align: 'right', columnWidth: _this11.filter.det_type === 'timesheet' ? 6 : 7 }, { text: 'A', value: 'tot_absent', class: 'red--text pa-2 text-xs-center', align: 'right', columnWidth: _this11.filter.det_type === 'timesheet' ? 6 : 7 }, { text: 'Billable', value: 'tot_billable', class: 'success white--text pa-2 text-xs-center', align: 'right', columnWidth: 11 }];
          response.data.forEach(function (rec) {
            // 1. one line item per staff
            if (tmpStaffId !== rec.staff_id) {
              _this11.attReportDet.push({
                staff_id: rec.staff_id,
                staff_name: rec.staff_name,
                staff_role_id: rec.staff_role_id,
                staff_role: rec.staff_role,
                vendor_emp_id: rec.vendor_emp_id,
                calendar: [],
                tot_present: 0,
                tot_absent: 0,
                tot_wo: 0,
                tot_holiday: 0,
                tot_ot: 0,
                tot_hd: 0,
                tot_pend: 0,
                tot_billable: 0,
                tot_leave: 0
              });
              idx = _this11.attReportDet.length - 1;
              tmpStaffId = rec.staff_id;
            }
            curAtt = rec.attendance ? rec.attendance === 'Half Day' ? 'HD' : rec.attendance === 'Casual Leave' ? 'CL' : rec.attendance === 'Sick Leave' ? 'SL' : rec.attendance === 'Comp Off' ? 'C' : rec.attendance === 'Earned Leave' ? 'EL' : rec.attendance === 'Present + RL' ? 'P+R' : rec.attendance.charAt(0) : '';
            // 2. for summary
            if (curAtt) {
              if (rec.attendance.includes('Present')) {
                _this11.attReportDet[idx].tot_present++;
              } else if (rec.attendance.includes('Absent')) {
                _this11.attReportDet[idx].tot_absent++;
              } else if (rec.attendance.includes('Weekly Off')) {
                _this11.attReportDet[idx].tot_wo++;
              } else if (rec.attendance.includes('Holiday')) {
                _this11.attReportDet[idx].tot_holiday++;
              } else if (rec.attendance.includes('Leave') || rec.attendance === 'Comp Off') {
                _this11.attReportDet[idx].tot_leave++;
              } else if (rec.attendance === 'Half Day') {
                _this11.attReportDet[idx].tot_hd++;
                // adjust present and absent accordingly
                _this11.attReportDet[idx].tot_present += 0.5;
                _this11.attReportDet[idx].tot_absent += 0.5;
              }
              if (rec.sby_vendor_emp_id || rec.sby_temp_staff_name) {
                curAtt = curAtt + '+S';
              }
              // handle ot seperately
              if (rec.attendance.includes('OT')) {
                _this11.attReportDet[idx].tot_ot++;
                curAtt = curAtt + '+O';
              }
              if (rec.attendance.includes('Present + RL')) {
                _this11.attReportDet[idx].tot_ot++;
              }
              _this11.attReportDet[idx].tot_billable = _this11.attReportDet[idx].tot_present + _this11.attReportDet[idx].tot_wo + _this11.attReportDet[idx].tot_holiday + _this11.attReportDet[idx].tot_ot + _this11.attReportDet[idx].tot_leave;
            } else {
              _this11.attReportDet[idx].tot_pend++;
            }
            // 3. dynamic dates for table heading
            if (!addedDates.includes(rec.att_dt)) {
              addedDates.push(rec.att_dt);
            }
            // 4.1 attendance detail for table
            // add timesheet details if req
            if (_this11.filter.det_type === 'timesheet' && curAtt && (curAtt === 'P' || curAtt === 'HD' || curAtt.includes('+O') || curAtt.includes('+S') || curAtt.includes('P+R'))) {
              curDet = _this11.handy.getTime(rec.check_in);
              curDet += '\n' + (rec.check_out ? _this11.handy.getTime(rec.check_out) : '');
              curDet += '\n' + (rec.check_out ? (_this11.handy.dateDiffInMins(new Date(rec.check_in), new Date(rec.check_out)) / 60).toFixed(1) + 'hrs' : '');
            } else if (_this11.filter.det_type === 'inOutSheet' && curAtt && (curAtt === 'P' || curAtt === 'HD' || curAtt.includes('+O') || curAtt.includes('+S') || curAtt.includes('P+R'))) {
              var det = rec.in_out_time ? rec.in_out_time.split(',').map(function (item) {
                return item.trim();
              }) : '';
              curDet = det ? det.join('\n') : '';
            } else {
              curDet = '';
            }
            _this11.attReportDet[idx].calendar.push({
              att_dt: rec.att_dt,
              attendance: curAtt,
              att_detail: curAtt.includes('+S') ? '' : curDet
            });
            // 5. standby handling
            if (rec.sby_vendor_emp_id || rec.sby_temp_staff_name) {
              // add a line item for standby
              sbyList.push({
                sby_staff_id: rec.sby_vendor_emp_id || rec.sby_temp_staff_name,
                staff_name: rec.sby_vendor_emp_id ? _this11.vendorStandby.find(function (emp) {
                  return emp.vendor_emp_id === rec.sby_vendor_emp_id;
                }).emp_name : rec.sby_temp_staff_name,
                staff_role_id: rec.staff_role_id,
                vendor_emp_id: rec.sby_vendor_emp_id || '',
                staff_role: rec.staff_role + ' [Sby]',
                tot_ot: 1,
                tot_billable: 1,
                calendar: [{ att_dt: rec.att_dt, attendance: 'S', att_detail: curDet, tmp_dt: tmpDt }]
              });
            }
          });
          // post processing
          // sort dates in case
          addedDates = addedDates.sort();
          addedDates.forEach(function (dt) {
            // a.create dynamic column headers based on dates accumalated
            tmpDt = new Date(dt);
            tmpDt = _this11.filter.det_type === 'inOutSheet' ? tmpDt.toLocaleString('en-us', { month: 'short' }) + '-' + tmpDt.getDate() : tmpDt.getDate() + '/' + (tmpDt.getMonth() + 1);
            _this11.repDetCalHeadSm.splice(dtIdx++, 0, {
              text: tmpDt, value: tmpDt, class: 'pa-0 text-xs-center', align: 'center', columnWidth: _this11.filter.det_type === 'timesheet' ? 6 : 5
            });
            // b. arrange attendance based on sorted dates
            _this11.attReportDet.forEach(function (det) {
              calDtIdx = det.calendar.findIndex(function (cal) {
                return cal.att_dt === dt;
              });
              if (calDtIdx === -1) {
                curAtt = '-';
                curDet = '';
                det.calendar.push({ att_dt: dt, attendance: curAtt });
              } else {
                curAtt = det.calendar[calDtIdx].attendance;
                curDet = det.calendar[calDtIdx].att_detail;
                det.calendar.push(det.calendar[calDtIdx]);
                det.calendar.splice(calDtIdx, 1);
              }
              // detail for pdf/csv export
              det[tmpDt] = curAtt + (curAtt && curDet ? '\n' + curDet : '');
            });
          });
          // insert standbys at appropriate places (grouped by role)
          if (sbyList.length) {
            var roleSbyList = [];
            var curStaffIdx = -1;
            var roleStaffSbyList = [];
            var roleIdx = -1;
            var calDtIdx = -1;
            __WEBPACK_IMPORTED_MODULE_4__utils_handy___default.a.unique(sbyList.map(function (rec) {
              return rec.staff_role_id;
            })).forEach(function (role) {
              var _attReportDet;

              // filter each role
              roleSbyList = sbyList.filter(function (sby) {
                return sby.staff_role_id === role;
              });
              // group by staff
              roleSbyList.forEach(function (sby) {
                curStaffIdx = roleStaffSbyList.findIndex(function (rsby) {
                  return rsby.sby_staff_id === sby.sby_staff_id;
                });
                if (curStaffIdx >= 0) {
                  roleStaffSbyList[curStaffIdx].tot_ot++;
                  roleStaffSbyList[curStaffIdx].tot_billable++;
                  roleStaffSbyList[curStaffIdx].calendar.push(sby.calendar[0]);
                  roleStaffSbyList[curStaffIdx][sby.calendar[0].tmp_dt] = 'S'; // for pdf/csv
                } else {
                  roleStaffSbyList.push(sby);
                }
              });
              // fill-in attendance for non standby dates for every staff
              roleStaffSbyList.forEach(function (rsby) {
                // a. fill-in attendance for non standby dates
                addedDates.forEach(function (dt) {
                  tmpDt = new Date(dt);
                  tmpDt = _this11.filter.det_type === 'inOutSheet' ? tmpDt.toLocaleString('en-us', { month: 'short' }) + '-' + tmpDt.getDate() : tmpDt.getDate() + '/' + (tmpDt.getMonth() + 1);
                  calDtIdx = rsby.calendar.findIndex(function (cal) {
                    return cal.att_dt === dt;
                  });
                  if (calDtIdx === -1) {
                    curAtt = '-';
                    curDet = '';
                    rsby.calendar.push({ att_dt: dt, attendance: curAtt });
                  } else {
                    curAtt = 'S';
                    curDet = rsby.calendar[calDtIdx].att_detail;
                    rsby.calendar.push(rsby.calendar[calDtIdx]);
                    rsby.calendar.splice(calDtIdx, 1);
                  }
                  rsby[tmpDt] = curAtt + (curDet ? '\n' + curDet : ''); // for pdf/csv
                });
              });
              // insert all these staff records at appropriate place in main attendance (end of concerned group)
              roleIdx = _this11.attReportDet.map(function (rep) {
                return rep.staff_role_id;
              }).lastIndexOf(role);
              (_attReportDet = _this11.attReportDet).splice.apply(_attReportDet, [roleIdx + 1, 0].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(roleStaffSbyList)));
              roleStaffSbyList = [];
            }); // for ever role
          }
        } else {
          _this11.attReportDet = response.data;
          _this11.attReportDet.forEach(function (rec) {
            rec.tot_present = rec.tot_present ? rec.tot_present + rec.tot_hd / 2 : 0;
            rec.tot_absent = rec.tot_absent ? rec.tot_absent + rec.tot_hd / 2 : 0;
            rec.tot_contracted = rec.tot_contracted ? rec.tot_contracted : 0;
            rec.tot_ot = rec.tot_ot ? rec.tot_ot : 0;
            rec.tot_wo = rec.tot_wo ? rec.tot_wo : 0;
            rec.tot_holiday = rec.tot_holiday ? rec.tot_holiday : 0;
            rec.tot_leave = rec.tot_leave ? rec.tot_leave : 0;
            rec.vendor_emp_id = rec.vendor_emp_id ? rec.vendor_emp_id : '-';
            rec.tot_billable = rec.tot_present + rec.tot_wo + rec.tot_holiday + rec.tot_ot + rec.tot_leave;
          });
        }
        _this11.pageRefKey++; // forces the detail table to re-render
        _this11.load = false;
      }).catch(function (err) {
        _this11.msg(err.response.data, true);
        _this11.load = false;
      });
    },
    loadRoles: function loadRoles() {
      var _this12 = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a.COMM_ID
        }
        // list of available roles
      };this.axios.get(__WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a.API_URL + '/getStaffRolesByCommId/', qry).then(function (response) {
        _this12.roles = response.data;
      }).catch(function (err) {
        _this12.msg(err.response.data, true);
        _this12.roles = [];
      });
    },
    loadNonBillableStaffs: function loadNonBillableStaffs() {
      var _this13 = this;

      var curShiftId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a.COMM_ID,
          tab: this.tab,
          shift_id: curShiftId
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a.API_URL + '/getNonBillableStaffs/', qry).then(function (response) {
        _this13.attNonBill.tot_nonbillable_staff = response.data[0].tot_nonbillable_staff;
        if (_this13.attNonBill.tot_nonbillable_staff === 0) {
          _this13.filter.billable = 'Billable';
        }
        _this13.$forceUpdate();
      }).catch(function (err) {
        _this13.msg(err, true);
      });
    },
    loadNonBillStaffasSby: function loadNonBillStaffasSby(curAttDet) {
      var _this14 = this;

      if (curAttDet.attendance === 'Absent' || curAttDet.attendance === 'Comp Off' || curAttDet.attendance === 'Weekly Off' || curAttDet.attendance === 'Holiday' || curAttDet.attendance.includes('Leave')) {
        var qry = {
          params: {
            comm_id: __WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a.COMM_ID,
            vendor_id: __WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a.FM_VENDOR_ID,
            staff_role_id: curAttDet.staff_role_id,
            from_dt: curAttDet.att_dt
          }
        };
        this.axios.get(__WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a.API_URL + '/getNonBillableEmpForSby/', qry).then(function (response) {
          var nonBillableStaff = response.data;
          for (var i = 0; i < nonBillableStaff.length; i++) {
            if (__WEBPACK_IMPORTED_MODULE_4__utils_handy___default.a.formatDBDateTime(nonBillableStaff[i].check_in) && nonBillableStaff[i].check_out === null) {
              _this14.lAttDet.sby_vendor_emp_pair = { vendor_emp_id: nonBillableStaff[i].vendor_emp_id, emp_name_and_id: nonBillableStaff[i].emp_name_with_id };
              _this14.lAttDet.checkInTime = __WEBPACK_IMPORTED_MODULE_4__utils_handy___default.a.getTime(nonBillableStaff[i].check_in);
              i = nonBillableStaff.length;
            }
          }
          _this14.$forceUpdate();
        }).catch(function (err) {
          _this14.msg(err, true);
        });
      } else {
        this.lAttDet.sby_vendor_emp_pair = {};
      }
    },
    refreshNonBillAttReportDet: function refreshNonBillAttReportDet(curChip) {
      var _this15 = this;

      this.filter.billable = curChip;
      if (curChip === 'Non-billable') {
        var qry = {
          params: {
            comm_id: __WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a.COMM_ID,
            from_dt: this.lCurrentFrom,
            to_dt: this.lCurrentTo,
            vendor_list: this.filter.vendor_list.map(function (rec) {
              return rec.vendor_id;
            }),
            shift_id: this.lCurrentShiftId,
            is_billable: 0
          }
        };
        this.nonBillshiftSummary[this.lCurrentShiftId] = [];
        this.axios.get(__WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a.API_URL + '/getAttendanceByCommId/', qry).then(function (response) {
          _this15.nonBillshiftSummary[_this15.lCurrentShiftId] = response.data;
          _this15.$forceUpdate();
        }).catch(function (err) {
          _this15.nonBillshiftSummary = {};
          _this15.msg(err.response.data, true);
        });
      } else {
        this.loadAttSummary(this.filter.current_period, curChip);
      }
    },
    refreshTab: function refreshTab(curTab) {
      var curDate = new Date();
      if (!this.filter) {
        this.filter = {
          current_period: 'today',
          vendor_list: [],
          role_list: [],
          from_dt: __WEBPACK_IMPORTED_MODULE_4__utils_handy___default.a.formatDBDate(new Date(curDate.getFullYear(), curDate.getMonth(), 1)),
          to_dt: __WEBPACK_IMPORTED_MODULE_4__utils_handy___default.a.formatDBDate(curDate),
          det_type: 'date'
        };
      }
      this.filter.billable = 'Billable';
      if (curTab === 'reports') {
        this.loadRoles();
      }
      // load report for the entire month by default if user going to report tab first time
      if (curTab === 'attendance') {
        this.tab = 'tab-0';
        this.loadAttSummary(this.filter.current_period, this.filter.billable);
      } else {
        this.tab = 'tab-1';
        this.refreshAttReport(null, 'Billable');
        this.loadNonBillableStaffs();
      }
      this.lAction = 'view';
    },
    loadAttDevType: function loadAttDevType() {
      var _this16 = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a.COMM_ID
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a.API_URL + '/getFacilityOtherConfigsByCommId/', qry).then(function (response) {
        if (response.data.length) {
          _this16.att_dev_type = response.data[0].att_dev_type;
          _this16.comm_id = response.data[0].comm_id;
        } else {
          _this16.att_dev_type = '';
          _this16.comm_id = __WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a.COMM_ID;
        }
      }).catch(function (err) {
        _this16.msg(err.response.data, true);
        _this16.lAttDet = [];
      });
    }
  }
});

/***/ }),

/***/ 759:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(719);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),

/***/ 811:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-tabs', {
    attrs: {
      "flat": "",
      "color": "primary",
      "dark": "",
      "grow": "",
      "height": "40",
      "fixed-tabs": ""
    },
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, _vm._l((_vm.tabitems), function(tabitem, n) {
    return _c('v-tab', {
      key: n,
      attrs: {
        "href": ("#tab-" + n)
      },
      on: {
        "click": function($event) {
          return _vm.refreshTab(tabitem)
        }
      }
    }, [_vm._v("\n      " + _vm._s(tabitem) + "\n    ")])
  }), 1), _vm._v(" "), _c('v-container', {
    key: _vm.pageRefKey,
    staticClass: "pa-1",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-tabs-items', {
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, [(_vm.lAction === 'view') ? _c('v-tab-item', {
    key: 0,
    attrs: {
      "value": "tab-0"
    }
  }, [_c('v-layout', {
    staticClass: "pa-1",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-tabs', {
    model: {
      value: (_vm.attTab),
      callback: function($$v) {
        _vm.attTab = $$v
      },
      expression: "attTab"
    }
  }, _vm._l((_vm.attTabItems), function(attitem, n) {
    return _c('v-tab', {
      key: n,
      attrs: {
        "href": ("#tab-" + n)
      },
      on: {
        "click": function($event) {
          return _vm.loadAttSummary(attitem, _vm.filter.billable)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(attitem) + "\n                  ")])
  }), 1)], 1), _vm._v(" "), (_vm.attTab === 'tab-3') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-layout', {
    staticClass: "ml-2",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-dialog', {
    ref: "dlgPeriodFrom",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.filter.from_dt
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.filter, "from_dt", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.filter, "from_dt", $event)
      }
    },
    model: {
      value: (_vm.dlgPeriodFrom),
      callback: function($$v) {
        _vm.dlgPeriodFrom = $$v
      },
      expression: "dlgPeriodFrom"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "From",
      "append-icon": "event",
      "readonly": "",
      "clearable": "",
      "hide-details": ""
    },
    slot: "activator",
    model: {
      value: (_vm.filter.from_dt),
      callback: function($$v) {
        _vm.$set(_vm.filter, "from_dt", $$v)
      },
      expression: "filter.from_dt"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "first-day-of-week": "1"
    },
    model: {
      value: (_vm.filter.from_dt),
      callback: function($$v) {
        _vm.$set(_vm.filter, "from_dt", $$v)
      },
      expression: "filter.from_dt"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgPeriodFrom = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dlgPeriodFrom.save(_vm.filter.from_dt)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-dialog', {
    ref: "dlgPeriodTo",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.filter.to_dt
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.filter, "to_dt", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.filter, "to_dt", $event)
      }
    },
    model: {
      value: (_vm.dlgPeriodTo),
      callback: function($$v) {
        _vm.dlgPeriodTo = $$v
      },
      expression: "dlgPeriodTo"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "To",
      "append-icon": "event",
      "readonly": "",
      "clearable": "",
      "hide-details": ""
    },
    slot: "activator",
    model: {
      value: (_vm.filter.to_dt),
      callback: function($$v) {
        _vm.$set(_vm.filter, "to_dt", $$v)
      },
      expression: "filter.to_dt"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "first-day-of-week": "1"
    },
    model: {
      value: (_vm.filter.to_dt),
      callback: function($$v) {
        _vm.$set(_vm.filter, "to_dt", $$v)
      },
      expression: "filter.to_dt"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgPeriodTo = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dlgPeriodTo.save(_vm.filter.to_dt)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs2": ""
    }
  }, [_c('v-btn', {
    staticClass: "accent",
    attrs: {
      "fab": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.loadAttSummary('month/period', _vm.filter.billable)
      }
    }
  }, [_vm._v("Go")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.attTab !== 'tab-3' && _vm.$vuetify.breakpoint.smAndUp) ? _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Vendor filter",
      "items": _vm.vendors,
      "item-value": "vendor_id",
      "item-text": "vendor_name",
      "placeholder": "All",
      "clearable": "",
      "chips": "",
      "multiple": "",
      "hide-details": "",
      "return-object": ""
    },
    on: {
      "input": function($event) {
        return _vm.loadAttSummary(_vm.filter.current_period, _vm.filter.billable)
      }
    },
    model: {
      value: (_vm.filter.vendor_list),
      callback: function($$v) {
        _vm.$set(_vm.filter, "vendor_list", $$v)
      },
      expression: "filter.vendor_list"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-btn', {
    class: _vm.$vuetify.breakpoint.smAndUp ? 'mt-3' : 'mt-0',
    on: {
      "click": function($event) {
        return _vm.showAttLog()
      }
    }
  }, [_vm._v("View " + _vm._s(_vm.filter.current_period) + "'s Log")])], 1), _vm._v(" "), (_vm.shifts.length > 0) ? _c('v-flex', {
    staticClass: "py-2 text-xs-right",
    attrs: {
      "xs12": ""
    }
  }, _vm._l((_vm.billableChip), function(chip, index) {
    return _c('span', {
      key: index
    }, [_c('v-chip', {
      class: _vm.filter.billable === chip ? 'info white--text' : '',
      style: (_vm.$vuetify.breakpoint.smAndUp ? '' : 'width:30%;'),
      attrs: {
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.loadAttSummary(_vm.filter.current_period, chip)
        }
      }
    }, [_vm._v("\n            " + _vm._s(chip) + "\n          ")])], 1)
  }), 0) : _vm._e(), _vm._v(" "), _vm._l((_vm.shifts), function(shift, i) {
    return _c('v-flex', {
      key: i,
      staticClass: "text-xs-center",
      attrs: {
        "xs6": "",
        "sm3": ""
      }
    }, [_c('v-card', {
      class: shift.shift_id === _vm.lCurrentShiftId ? 'accent lighten-1 elevation-10' : '',
      nativeOn: {
        "click": function($event) {
          return _vm.showShift(shift.shift_id)
        }
      }
    }, [_c('v-card-title', {
      staticClass: "pa-2 grey lighten-4"
    }, [_c('div', {
      staticClass: "title grey--text"
    }, [_vm._v(_vm._s(_vm.$vuetify.breakpoint.smAndUp ? shift.shift_abbr : shift.shift_abbr.substring(0, 10)))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
      staticClass: "ma-0",
      attrs: {
        "icon": "",
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.showShiftDet(shift.shift_id)
        }
      }
    }, [_c('v-icon', [_vm._v("open_in_new")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
      staticClass: "pa-2"
    }, [_c('v-layout', {
      staticClass: "subheading",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('div', {
      staticClass: "display-1"
    }, [_vm._v(_vm._s(_vm.shiftSummary[shift.shift_id].attAve >= 0 ? (_vm.shiftSummary[shift.shift_id].attAve + '%') : '-'))]), _vm._v(" "), (_vm.shiftSummary[shift.shift_id].attAve > 100) ? _c('div', {
      staticClass: "caption grey--text"
    }, [_vm._v("\n                  It is more than 100% due to SBy/OT\n                ")]) : _vm._e()]), _vm._v(" "), _c('v-divider', {
      staticClass: "ma-1"
    }), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('div', {
      staticClass: "green--text lighten-2"
    }, [_vm._v("\n                  Present\n                ")]), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "display-1"
    }, [_vm._v(_vm._s(_vm.shiftSummary[shift.shift_id].totPresent))]), _vm._v("/"), _c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(_vm.shiftSummary[shift.shift_id].totStaff))])])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs6": ""
      }
    }, [_c('v-card', {
      staticClass: "grey lighten-4",
      attrs: {
        "flat": ""
      }
    }, [_c('div', {
      staticClass: "info--text grey lighten-3"
    }, [_vm._v("\n                        Leave/Ab\n                      ")]), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(_vm.shiftSummary[shift.shift_id].totAbsent + _vm.shiftSummary[shift.shift_id].totLeave))])])])], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs6": ""
      }
    }, [_c('v-card', {
      staticClass: "grey lighten-4",
      attrs: {
        "flat": ""
      }
    }, [_c('div', {
      staticClass: "info--text grey lighten-3"
    }, [_vm._v("\n                        Weekoff\n                      ")]), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(_vm.shiftSummary[shift.shift_id].totWO))])])])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs6": ""
      }
    }, [_c('v-card', {
      staticClass: "grey lighten-4",
      attrs: {
        "flat": ""
      }
    }, [_c('div', {
      staticClass: "info--text grey lighten-3"
    }, [_vm._v("\n                        SBy/OT\n                      ")]), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(_vm.shiftSummary[shift.shift_id].totOT))])])])], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs6": ""
      }
    }, [_c('v-card', {
      staticClass: "grey lighten-4",
      attrs: {
        "flat": ""
      }
    }, [_c('div', {
      staticClass: "info--text grey lighten-3"
    }, [_vm._v("\n                        " + _vm._s((_vm.$vuetify.breakpoint.smAndUp ? 'Pending' : 'Pen'))), _c('span', {
      staticClass: "caption"
    }, [_vm._v(" In|Out")])]), _vm._v(" "), _c('div', [_c('span', {
      class: _vm.shiftSummary[shift.shift_id].totNotYetIn ? 'red--text title' : 'title'
    }, [_vm._v(_vm._s(_vm.shiftSummary[shift.shift_id].totNotYetIn))]), _vm._v(" "), _c('span', {
      staticClass: "grey--text"
    }, [_vm._v("|")]), _vm._v(" "), _c('span', {
      class: _vm.shiftSummary[shift.shift_id].totNotYetOut ? 'warning--text title' : 'title'
    }, [_vm._v(_vm._s(_vm.shiftSummary[shift.shift_id].totNotYetOut))])])])], 1)], 1)], 1)], 1)], 1)], 1)], 1)
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "pa-2 grey"
  }, [_c('div', {
    staticClass: "title white--text"
  }, [_vm._v("Key Staffs [" + _vm._s(_vm.lCurrentShift) + "]")])]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-data-table', {
    attrs: {
      "headers": _vm.$vuetify.breakpoint.smAndUp ? _vm.keyStaffHeadSm : _vm.keyStaffHead,
      "items": _vm.keyStaffs,
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          class: props.item.attendance ? '' : 'red--text'
        }, [(_vm.$vuetify.breakpoint.smAndUp) ? _c('td', {
          staticClass: "pa-3"
        }, [_vm._v(_vm._s(_vm.handy.formatDBDate(props.item.att_dt)))]) : _vm._e(), _vm._v(" "), _c('td', {
          staticClass: "pa-3"
        }, [_vm._v(_vm._s(props.item.staff_role))]), _vm._v(" "), _c('td', {
          staticClass: "pa-3"
        }, [_vm._v(_vm._s(props.item.staff_name))]), _vm._v(" "), _c('td', {
          staticClass: "pa-3"
        }, [_vm._v(_vm._s(props.item.staff_mobile))]), _vm._v(" "), _c('td', {
          staticClass: "pa-3"
        }, [_vm._v(_vm._s(props.item.attendance ? props.item.attendance : 'Pending'))]), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', {
          class: 'pa-3' + (props.item.sby_temp_staff_name ? ' red' : '')
        }, [_vm._v(_vm._s(props.item.standby))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', {
          staticClass: "pa-3"
        }, [_vm._v(_vm._s(props.item.check_in ? _vm.handy.formatDBDateTime(props.item.check_in) : '-'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', {
          staticClass: "pa-3"
        }, [_vm._v(_vm._s(props.item.check_out ? _vm.handy.formatDBDateTime(props.item.check_out) : '-'))]) : _vm._e()])]
      }
    }], null, false, 2088263442)
  })], 1)], 1)], 1)], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.lAction === 'view') ? _c('v-tab-item', {
    key: 1,
    attrs: {
      "value": "tab-1"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "grey lighten-4"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs7": "",
      "sm4": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Vendor",
      "items": _vm.vendors,
      "item-value": "vendor_id",
      "item-text": "vendor_name",
      "placeholder": "All",
      "clearable": "",
      "multiple": "",
      "hide-details": "",
      "return-object": ""
    },
    model: {
      value: (_vm.filter.vendor_list),
      callback: function($$v) {
        _vm.$set(_vm.filter, "vendor_list", $$v)
      },
      expression: "filter.vendor_list"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": "",
      "sm2": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Services",
      "items": _vm.roles,
      "item-text": "staff_role",
      "item-value": "staff_role_id",
      "placeholder": "All",
      "hide-details": "",
      "multiple": "",
      "clearable": "",
      "return-object": ""
    },
    model: {
      value: (_vm.filter.role_list),
      callback: function($$v) {
        _vm.$set(_vm.filter, "role_list", $$v)
      },
      expression: "filter.role_list"
    }
  })], 1), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('v-flex', {
    attrs: {
      "sm1": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": "",
      "sm2": ""
    }
  }, [_c('v-dialog', {
    ref: "dlgFromDt",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.filter.from_dt
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.filter, "from_dt", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.filter, "from_dt", $event)
      }
    },
    model: {
      value: (_vm.dlgFromDt),
      callback: function($$v) {
        _vm.dlgFromDt = $$v
      },
      expression: "dlgFromDt"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "From",
      "append-icon": "event",
      "readonly": "",
      "clearable": "",
      "hide-details": ""
    },
    slot: "activator",
    model: {
      value: (_vm.filter.from_dt),
      callback: function($$v) {
        _vm.$set(_vm.filter, "from_dt", $$v)
      },
      expression: "filter.from_dt"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "first-day-of-week": "1"
    },
    model: {
      value: (_vm.filter.from_dt),
      callback: function($$v) {
        _vm.$set(_vm.filter, "from_dt", $$v)
      },
      expression: "filter.from_dt"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgFromDt = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dlgFromDt.save(_vm.filter.from_dt)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": "",
      "sm2": ""
    }
  }, [_c('v-dialog', {
    ref: "dlgToDt",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.filter.to_dt
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.filter, "to_dt", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.filter, "to_dt", $event)
      }
    },
    model: {
      value: (_vm.dlgToDt),
      callback: function($$v) {
        _vm.dlgToDt = $$v
      },
      expression: "dlgToDt"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "To",
      "append-icon": "event",
      "readonly": "",
      "clearable": "",
      "hide-details": ""
    },
    slot: "activator",
    model: {
      value: (_vm.filter.to_dt),
      callback: function($$v) {
        _vm.$set(_vm.filter, "to_dt", $$v)
      },
      expression: "filter.to_dt"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "first-day-of-week": "1"
    },
    model: {
      value: (_vm.filter.to_dt),
      callback: function($$v) {
        _vm.$set(_vm.filter, "to_dt", $$v)
      },
      expression: "filter.to_dt"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgToDt = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dlgToDt.save(_vm.filter.to_dt)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs2": "",
      "sm1": ""
    }
  }, [_c('v-btn', {
    staticClass: "accent",
    attrs: {
      "fab": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.refreshAttReport(_vm.lRep.agreedHeadCount, 'Billable')
      }
    }
  }, [_vm._v("\n      Go\n    ")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pt-2"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Attendance Summary")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("For period of " + _vm._s(_vm.filter.rep_days) + " days")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pb-0",
    attrs: {
      "xs7": "",
      "sm3": ""
    }
  }, _vm._l((_vm.billableChip), function(chip, index) {
    return _c('span', {
      key: index
    }, [_c('v-chip', {
      class: _vm.enableChip === chip ? 'info white--text' : '',
      style: (_vm.$vuetify.breakpoint.smAndUp ? '' : 'width:30%;'),
      attrs: {
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.refreshAttReport(null, chip)
        }
      }
    }, [_vm._v("\n              " + _vm._s(chip) + "\n            ")])], 1)
  }), 0), _vm._v(" "), _c('v-flex', {
    staticClass: "py-1 my-0",
    attrs: {
      "xs5": "",
      "sm3": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "py-1 my-0",
    staticStyle: {
      "text-align": "center",
      "font-size": "8px"
    },
    attrs: {
      "label": "Show Agreed",
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        return _vm.refreshAttReport(_vm.lRep.agreedHeadCount, _vm.enableChip)
      }
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('span', {
          staticStyle: {
            "font-size": "14px"
          }
        }, [_vm._v("Show Agreed")])]
      },
      proxy: true
    }], null, false, 3162163078),
    model: {
      value: (_vm.lRep.agreedHeadCount),
      callback: function($$v) {
        _vm.$set(_vm.lRep, "agreedHeadCount", $$v)
      },
      expression: "lRep.agreedHeadCount"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right pa-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-download-as', {
    attrs: {
      "headers": _vm.lRep.agreedHeadCount ? _vm.repHeadCountSm : _vm.repHeadSm,
      "items": _vm.attReport,
      "title": "Attendance Summary",
      "fontsize": 8,
      "subtitle": (_vm.filter.vendor_list && _vm.filter.vendor_list.length ? _vm.filter.vendor_list.map(function (rec) { return rec.vendor_name; }).join() + ' - ' : '') + (_vm.filter.role_list && _vm.filter.role_list.length ? _vm.filter.role_list.map(function (rec) { return rec.staff_role; }).join() : '') + (' [' + _vm.handy.formatDate(_vm.filter.from_dt) + ' to ' + _vm.handy.formatDate(_vm.filter.to_dt) + '] (' + _vm.filter.rep_days + ' days)')
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-data-table', {
    staticClass: "elevation-3",
    attrs: {
      "headers": (_vm.$vuetify.breakpoint.smAndUp ? (_vm.lRep.agreedHeadCount ? _vm.repHeadCountSm : _vm.repHeadSm) : _vm.repHead),
      "items": _vm.attReport,
      "hide-actions": "",
      "search": _vm.search
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', [_vm._v(_vm._s(props.item.staff_role))]), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', {
          staticClass: "pa-2 text-xs-center"
        }, [_vm._v(_vm._s(props.item.tot_present))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', {
          staticClass: "pa-2 text-xs-center"
        }, [_vm._v(_vm._s(props.item.tot_wo))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', {
          staticClass: "pa-2 text-xs-center"
        }, [_vm._v(_vm._s(props.item.tot_holiday))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', {
          staticClass: "pa-2 text-xs-center"
        }, [_vm._v(_vm._s(props.item.tot_ot))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', {
          staticClass: "pa-2 text-xs-center"
        }, [_vm._v(_vm._s(props.item.tot_leave))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', {
          staticClass: "pa-2 text-xs-center"
        }, [_vm._v(_vm._s(props.item.tot_absent))]) : _vm._e(), _vm._v(" "), _c('td', {
          staticClass: "pa-2 accent lighten-3 text-xs-center"
        }, [_vm._v(_vm._s(props.item.tot_contracted))]), _vm._v(" "), _c('td', {
          staticClass: "pa-2 green lighten-3 text-xs-center"
        }, [_vm._v(_vm._s(props.item.tot_billable))])])]
      }
    }], null, false, 1416169601)
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pt-2"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm2": ""
    }
  }, [_c('span', {
    staticClass: "subtitle font-weight-bold"
  }, [_vm._v("Attendance Detail")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right pt-0",
    attrs: {
      "xs12": "",
      "sm7": ""
    }
  }, [_c('v-radio-group', {
    attrs: {
      "mandatory": true,
      "row": "",
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        return _vm.refreshAttReportDet(_vm.filter.billable)
      }
    },
    model: {
      value: (_vm.filter.det_type),
      callback: function($$v) {
        _vm.$set(_vm.filter, "det_type", $$v)
      },
      expression: "filter.det_type"
    }
  }, [_c('v-radio', {
    attrs: {
      "value": "date"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('span', {
          staticStyle: {
            "font-size": "15px"
          }
        }, [_vm._v("Calendar View")])]
      },
      proxy: true
    }], null, false, 1605266347)
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Staff View",
      "value": "staff"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('span', {
          staticStyle: {
            "font-size": "15px"
          }
        }, [_vm._v("Staff View")])]
      },
      proxy: true
    }], null, false, 1799492703)
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Timesheet",
      "value": "timesheet"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('span', {
          staticStyle: {
            "font-size": "15px"
          }
        }, [_vm._v("Timesheet")])]
      },
      proxy: true
    }], null, false, 1516345582)
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "value": "inOutSheet"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('span', {
          staticStyle: {
            "font-size": "15px"
          }
        }, [_vm._v("In/Out Sheet")])]
      },
      proxy: true
    }], null, false, 2393189085)
  })], 1)], 1), _vm._v(" "), (_vm.attNonBill.tot_nonbillable_staff > 0) ? _c('v-flex', {
    staticClass: "pt-3 text-xs-right",
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, _vm._l((_vm.billableChip), function(chip, index) {
    return _c('span', {
      key: index
    }, [_c('v-chip', {
      class: _vm.filter.billable === chip ? 'info white--text' : '',
      style: (_vm.$vuetify.breakpoint.smAndUp ? '' : 'width:30%;'),
      attrs: {
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.refreshAttReportDet(chip)
        }
      }
    }, [_vm._v("\n                " + _vm._s(chip) + "\n              ")])], 1)
  }), 0) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pa-0 mt-1",
    attrs: {
      "append-icon": "search",
      "placeholder": _vm.$vuetify.breakpoint.smAndUp ? 'Search by role, name, etc.' : 'Search',
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-download-as', {
    attrs: {
      "headers": _vm.filter.det_type === 'staff' ? _vm.repDetStaffHeadSm : _vm.repDetCalHeadSm,
      "items": _vm.attReportDet,
      "title": "Attendance Detail",
      "subtitle": (_vm.filter.vendor_list && _vm.filter.vendor_list.length ? _vm.filter.vendor_list.map(function (rec) { return rec.vendor_name; }).join() + ' - ' : '') + (_vm.filter.role_list && _vm.filter.role_list.length ? _vm.filter.role_list.map(function (rec) { return rec.staff_role; }).join() : '') + (' [' + _vm.handy.formatDate(_vm.filter.from_dt) + ' to ' + _vm.handy.formatDate(_vm.filter.to_dt) + '] (' + _vm.filter.rep_days + ' days)'),
      "landscape": _vm.filter.det_type !== 'staff',
      "fontsize": _vm.filter.det_type === 'timesheet' ? 6 : 7,
      "cellpadding": _vm.filter.det_type === 'timesheet' ? 0.25 : 1,
      "legend": "P-Present, W-Weeklyoff, H-Holiday, HD-Half Day, S-Standby, O-Overtime, L-Leave, A-Absent, Billable=P+W+H+S/O+L"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-data-table', {
    staticClass: "elevation-3",
    attrs: {
      "headers": _vm.$vuetify.breakpoint.smAndUp ? (_vm.filter.det_type === 'staff' ? _vm.repDetStaffHeadSm : _vm.repDetCalHeadSm) : (_vm.filter.det_type === 'staff' ? _vm.repDetStaffHead : _vm.repDetCalHeadSm),
      "items": _vm.attReportDet,
      "hide-actions": "",
      "search": _vm.search,
      "sort-by": ['staff_role', 'staff_name'],
      "multi-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [(_vm.$vuetify.breakpoint.smAndUp || _vm.filter.det_type === 'date') ? _c('td', {
          staticClass: "pa-2"
        }, [_vm._v(_vm._s(props.item.staff_role))]) : _vm._e(), _vm._v(" "), _c('td', {
          staticClass: "pa-2"
        }, [_vm._v(_vm._s(props.item.staff_name))]), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp || _vm.filter.det_type === 'date') ? _c('td', {
          staticClass: "pa-2 text-xs-center"
        }, [_vm._v(_vm._s(props.item.vendor_emp_id))]) : _vm._e(), _vm._v(" "), _vm._l((props.item.calendar), function(calday, i) {
          return _c('td', {
            key: i,
            class: (_vm.filter.det_type === 'timesheet' ? 'px-1' : 'pa-0') + ' text-xs-center ' + (calday.attendance.includes('P') ? 'green' : calday.attendance.includes('A') ? 'red' : calday.attendance.includes('W') ? 'yellow' : (calday.attendance.includes('CL') || calday.attendance.includes('SL') || calday.attendance.includes('EL')) ? 'orange' : calday.attendance.includes('HD') ? 'green lighten-2' : calday.attendance.includes('H') ? 'blue' : !calday.attendance ? 'red lighten-4' : 'grey lighten-2')
          }, [(calday.attendance) ? _c('span', {
            class: calday.attendance === '-' ? 'title' : ''
          }, [_c('b', [_vm._v(_vm._s(calday.attendance))])]) : _c('span', {
            staticClass: "display-1 red--text"
          }, [_vm._v(".")]), _vm._v(" "), (calday.att_detail) ? _c('span', {
            staticClass: "caption"
          }, [_c('br'), _vm._l((calday.att_detail.split('\n')), function(line, i) {
            return _c('span', {
              key: i
            }, [_vm._v(_vm._s(line)), _c('br')])
          })], 2) : _vm._e()])
        }), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp || _vm.filter.det_type === 'date') ? _c('td', {
          staticClass: "pa-2 text-xs-right"
        }, [_vm._v(_vm._s(props.item.tot_present))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp || _vm.filter.det_type === 'date') ? _c('td', {
          staticClass: "pa-2 text-xs-right"
        }, [_vm._v(_vm._s(props.item.tot_wo))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp || _vm.filter.det_type === 'date') ? _c('td', {
          staticClass: "pa-2 text-xs-right"
        }, [_vm._v(_vm._s(props.item.tot_holiday))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp || _vm.filter.det_type === 'date') ? _c('td', {
          staticClass: "pa-2 text-xs-right"
        }, [_vm._v(_vm._s(props.item.tot_ot))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp || _vm.filter.det_type === 'date') ? _c('td', {
          staticClass: "pa-2 text-xs-right"
        }, [_vm._v(_vm._s(props.item.tot_leave))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp || _vm.filter.det_type === 'date') ? _c('td', {
          staticClass: "pa-2 text-xs-right"
        }, [_vm._v(_vm._s(props.item.tot_absent))]) : _vm._e(), _vm._v(" "), (_vm.filter.det_type === 'staff') ? _c('td', {
          staticClass: "pa-2 accent lighten-3 pa-2 text-xs-right"
        }, [_vm._v(_vm._s(props.item.tot_contracted))]) : _vm._e(), _vm._v(" "), _c('td', {
          staticClass: "pa-2 green lighten-3 pa-2 text-xs-right"
        }, [_vm._v(_vm._s(props.item.tot_billable))])], 2)]
      }
    }], null, false, 3429107591)
  })], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.lAction === 'att-det') ? _c('v-container', {
    staticClass: "pa-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "ma-1"
  }, [_c('v-card-title', {
    staticClass: "title grey lighten-4 pb-0"
  }, [_vm._v("\n          Attendance (" + _vm._s(_vm.lCurrentShift) + ")\n          "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.lAction = 'view', _vm.search = ''
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-card-actions', {
    staticClass: "grey lighten-4 caption"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pa-0 ml-1",
    attrs: {
      "append-icon": "search",
      "hide-details": "",
      "placeholder": "Search",
      "clearable": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-download-as', {
    attrs: {
      "headers": _vm.attHeadSm,
      "items": _vm.shiftSummary[_vm.lCurrentShiftId].detail,
      "title": "Attendance Details",
      "subtitle": _vm.lCurrentFrom + ' to ' + _vm.lCurrentTo + ' (' + _vm.lCurrentShift + ')',
      "landscape": true
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.attNonBill.tot_nonbillable_staff > 0) ? _c('v-flex', {
    class: _vm.attNonBill.tot_nonbillable_staff > 0 ? 'pt-3 pb-0' : '',
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, _vm._l((_vm.billableChip), function(chip, index) {
    return _c('span', {
      key: index
    }, [_c('v-chip', {
      class: _vm.filter.billable === chip ? 'info white--text' : '',
      style: (_vm.$vuetify.breakpoint.smAndUp ? '' : 'width:30%;'),
      attrs: {
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.refreshNonBillAttReportDet(chip)
        }
      }
    }, [_vm._v("\n                " + _vm._s(chip) + "\n              ")])], 1)
  }), 0) : _vm._e(), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.$vuetify.breakpoint.smAndUp ? _vm.attHeadSm : _vm.attHead,
      "items": _vm.filter.billable === 'Billable' ? _vm.shiftSummary[_vm.lCurrentShiftId].detail : _vm.nonBillshiftSummary[_vm.lCurrentShiftId],
      "hide-actions": "",
      "search": _vm.search,
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          class: ((props.item.attendance !== 'Absent' && props.item.attendance !== 'Weekly Off' && props.item.attendance !== 'Holiday') || (props.item.standby || props.item.sby_temp_staff_name)) && props.item.check_in && !props.item.check_out ? 'warning--text' : (props.item.attendance ? '' : 'red--text'),
          on: {
            "click": function($event) {
              return _vm.prepareEditDet(props.item)
            }
          }
        }, [(_vm.$vuetify.breakpoint.smAndUp) ? _c('td', {
          staticClass: "pa-3"
        }, [_vm._v(_vm._s(_vm.handy.formatDBDate(props.item.att_dt)))]) : _vm._e(), _vm._v(" "), _c('td', {
          staticClass: "pa-3"
        }, [_vm._v(_vm._s(props.item.staff_role))]), _vm._v(" "), _c('td', {
          staticClass: "pa-3"
        }, [_vm._v(_vm._s(props.item.staff_name) + " (" + _vm._s(props.item.vendor_emp_id) + ")")]), _vm._v(" "), _c('td', {
          staticClass: "pa-3"
        }, [_vm._v(_vm._s(props.item.attendance ? props.item.attendance : 'Pending'))]), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', {
          class: 'pa-3' + (props.item.sby_temp_staff_name ? ' red' : '')
        }, [_vm._v(_vm._s(props.item.standby))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', {
          staticClass: "pa-3"
        }, [_vm._v(_vm._s(props.item.check_in ? _vm.handy.formatDBDateTime(props.item.check_in) : '-'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', {
          staticClass: "pa-3"
        }, [_vm._v(_vm._s(props.item.check_out ? _vm.handy.formatDBDateTime(props.item.check_out) : '-'))]) : _vm._e(), _vm._v(" "), _c('td', {
          staticClass: "pa-3"
        }, [_vm._v(_vm._s(props.item.effective_work_hours ? props.item.effective_work_hours : '-'))])])]
      }
    }], null, false, 2916834934)
  })], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.lAction === 'att-log') ? _c('v-container', {
    staticClass: "pa-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "ma-1"
  }, [_c('v-card-title', {
    staticClass: "title grey lighten-4 pb-0"
  }, [_vm._v("\n          Attendance Log (" + _vm._s(_vm.handy.startWithUpper(_vm.filter.current_period)) + ")\n          "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.lAction = 'view', _vm.search = ''
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-card-actions', {
    staticClass: "grey lighten-4 caption"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pa-0 ml-1",
    attrs: {
      "append-icon": "search",
      "hide-details": "",
      "placeholder": "Search",
      "clearable": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-download-as', {
    attrs: {
      "headers": _vm.filterOfflineDev ? _vm.offlineDevHeadSm : _vm.attLogHeadSm,
      "items": _vm.filterOfflineDev ? _vm.offlineDevList : _vm.attLog,
      "title": "Attendance Log",
      "subtitle": _vm.lCurrentFrom + ' to ' + _vm.lCurrentTo
    }
  })], 1), _vm._v(" "), (_vm.offlineDevList.length) ? _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-chip', {
    class: 'ma-0 pa-0' + (_vm.filterOfflineDev ? ' info white--text' : ' red--text'),
    attrs: {
      "disabled": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.filterOfflineDev = !_vm.filterOfflineDev
      }
    }
  }, [_vm._v(_vm._s(_vm.offlineDevList.length) + " offline deviations")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.$vuetify.breakpoint.smAndUp ? (_vm.filterOfflineDev ? _vm.offlineDevHeadSm : _vm.attLogHeadSm) : (_vm.filterOfflineDev ? _vm.offlineDevHead : _vm.attLogHead),
      "items": _vm.filterOfflineDev ? _vm.offlineDevList : _vm.attLog,
      "hide-actions": "",
      "search": _vm.search,
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [(_vm.$vuetify.breakpoint.smAndUp || !_vm.filterOfflineDev) ? _c('td', [_vm._v(_vm._s(props.item.log_action))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.log_mode_and_loc))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp || !_vm.filterOfflineDev) ? _c('td', [_vm._v(_vm._s(_vm.handy.formatDBDateTime(props.item.log_time)))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.staff_name))]), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && !_vm.filterOfflineDev) ? _c('td', [_vm._v(_vm._s(props.item.staff_role))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && !_vm.filterOfflineDev) ? _c('td', [_vm._v(_vm._s(props.item.remark))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && !_vm.filterOfflineDev) ? _c('td', [_vm._v(_vm._s(props.item.approved_by))]) : _vm._e(), _vm._v(" "), (_vm.filterOfflineDev) ? _c('td', [_vm._v(_vm._s(props.item.offline_deviation))]) : _vm._e()])]
      }
    }], null, false, 1004482204)
  })], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "290px",
      "scrollable": ""
    },
    model: {
      value: (_vm.dlgAttDet),
      callback: function($$v) {
        _vm.dlgAttDet = $$v
      },
      expression: "dlgAttDet"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-form', {
    ref: "lForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveChanges()
      }
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title pb-0"
  }, [_vm._v("\n            " + _vm._s(_vm.lAttDet.staff_name + ' (' + _vm.lCurrentShift + ')') + "\n          ")]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Shift",
      "items": _vm.shifts,
      "item-value": "shift_id",
      "item-text": "shift_abbr",
      "error-messages": _vm.shiftNotRight && !_vm.shiftOverride ? 'Shift is not right based on check-in time' : ''
    },
    model: {
      value: (_vm.lAttDet.shift_id),
      callback: function($$v) {
        _vm.$set(_vm.lAttDet, "shift_id", $$v)
      },
      expression: "lAttDet.shift_id"
    }
  })], 1), _vm._v(" "), (_vm.shiftNotRight) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Proceed with above shift"
    },
    model: {
      value: (_vm.shiftOverride),
      callback: function($$v) {
        _vm.shiftOverride = $$v
      },
      expression: "shiftOverride"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Attendance",
      "items": ['Present', 'Absent', 'Weekly Off', 'Half Day', 'Holiday', 'Present + OT', 'Weekly Off + OT', 'Holiday + OT', 'Present + RL', 'Casual Leave', 'Earned Leave', 'Sick Leave', 'Comp Off']
    },
    on: {
      "input": function($event) {
        return _vm.loadNonBillStaffasSby(_vm.lAttDet)
      }
    },
    model: {
      value: (_vm.lAttDet.attendance),
      callback: function($$v) {
        _vm.$set(_vm.lAttDet, "attendance", $$v)
      },
      expression: "lAttDet.attendance"
    }
  })], 1), _vm._v(" "), (_vm.lAttDet.attendance === 'Absent' || (_vm.lAttDet.attendance && _vm.lAttDet.attendance.includes('Leave')) || _vm.lAttDet.attendance === 'Weekly Off' || _vm.lAttDet.attendance === 'Holiday') ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-combobox', {
    attrs: {
      "label": "Standby staff",
      "items": _vm.vendorStandby,
      "item-text": "emp_name_and_id",
      "item-value": "vendor_emp_id",
      "clearable": ""
    },
    model: {
      value: (_vm.lAttDet.sby_vendor_emp_pair),
      callback: function($$v) {
        _vm.$set(_vm.lAttDet, "sby_vendor_emp_pair", $$v)
      },
      expression: "lAttDet.sby_vendor_emp_pair"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.lAttDet.attendance === 'Absent' || (_vm.lAttDet.attendance && _vm.lAttDet.attendance.includes('Leave')) || _vm.lAttDet.attendance === 'Weekly Off' || _vm.lAttDet.attendance === 'Holiday') ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Temporary Staff",
      "hint": "Staff deployed temporarily in case",
      "persistent-hint": "",
      "clearable": ""
    },
    model: {
      value: (_vm.lAttDet.sby_temp_staff_name),
      callback: function($$v) {
        _vm.$set(_vm.lAttDet, "sby_temp_staff_name", $$v)
      },
      expression: "lAttDet.sby_temp_staff_name"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs7": ""
    }
  }, [_c('v-dialog', {
    ref: "dlgCheckIn",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.lAttDet.checkInDt
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lAttDet, "checkInDt", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lAttDet, "checkInDt", $event)
      }
    },
    model: {
      value: (_vm.dlgCheckIn),
      callback: function($$v) {
        _vm.dlgCheckIn = $$v
      },
      expression: "dlgCheckIn"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Check-in",
      "append-icon": "event",
      "readonly": "",
      "clearable": ""
    },
    slot: "activator",
    model: {
      value: (_vm.lAttDet.checkInDt),
      callback: function($$v) {
        _vm.$set(_vm.lAttDet, "checkInDt", $$v)
      },
      expression: "lAttDet.checkInDt"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "first-day-of-week": "1",
      "min": _vm.handy.formatDBDate(_vm.lAttDet.checkInMinDt),
      "max": _vm.handy.formatDBDate(_vm.lAttDet.checkInMaxDt)
    },
    on: {
      "change": function($event) {
        return _vm.GetCheckOutDate(_vm.lAttDet.checkInDt)
      }
    },
    model: {
      value: (_vm.lAttDet.checkInDt),
      callback: function($$v) {
        _vm.$set(_vm.lAttDet, "checkInDt", $$v)
      },
      expression: "lAttDet.checkInDt"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgCheckIn = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dlgCheckIn.save(_vm.lAttDet.checkInDt)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-dialog', {
    ref: "dlgCheckInTime",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.lAttDet.checkInTime
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lAttDet, "checkInTime", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lAttDet, "checkInTime", $event)
      }
    },
    model: {
      value: (_vm.dlgCheckInTime),
      callback: function($$v) {
        _vm.dlgCheckInTime = $$v
      },
      expression: "dlgCheckInTime"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "append-icon": "access_time",
      "clearable": "",
      "readonly": ""
    },
    on: {
      "input": function($event) {
        _vm.lAttDet.checkInTime = null
      }
    },
    slot: "activator",
    model: {
      value: (_vm.lAttDet.checkInTime),
      callback: function($$v) {
        _vm.$set(_vm.lAttDet, "checkInTime", $$v)
      },
      expression: "lAttDet.checkInTime"
    }
  }), _vm._v(" "), _c('v-time-picker', {
    model: {
      value: (_vm.lAttDet.checkInTime),
      callback: function($$v) {
        _vm.$set(_vm.lAttDet, "checkInTime", $$v)
      },
      expression: "lAttDet.checkInTime"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgCheckInTime = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dlgCheckInTime.save(_vm.lAttDet.checkInTime)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs7": ""
    }
  }, [_c('v-dialog', {
    ref: "dlgCheckOut",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.lAttDet.checkOutDt
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lAttDet, "checkOutDt", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lAttDet, "checkOutDt", $event)
      }
    },
    model: {
      value: (_vm.dlgCheckOut),
      callback: function($$v) {
        _vm.dlgCheckOut = $$v
      },
      expression: "dlgCheckOut"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Check-out",
      "append-icon": "event",
      "readonly": "",
      "clearable": ""
    },
    slot: "activator",
    model: {
      value: (_vm.lAttDet.checkOutDt),
      callback: function($$v) {
        _vm.$set(_vm.lAttDet, "checkOutDt", $$v)
      },
      expression: "lAttDet.checkOutDt"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "first-day-of-week": "1",
      "min": _vm.lAttDet.checkInDt,
      "max": _vm.handy.formatDBDate(_vm.lAttDet.checkOutMaxDt)
    },
    model: {
      value: (_vm.lAttDet.checkOutDt),
      callback: function($$v) {
        _vm.$set(_vm.lAttDet, "checkOutDt", $$v)
      },
      expression: "lAttDet.checkOutDt"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgCheckOut = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dlgCheckOut.save(_vm.lAttDet.checkOutDt)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-dialog', {
    ref: "dlgCheckOutTime",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.lAttDet.checkOutTime
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lAttDet, "checkOutTime", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lAttDet, "checkOutTime", $event)
      }
    },
    model: {
      value: (_vm.dlgCheckOutTime),
      callback: function($$v) {
        _vm.dlgCheckOutTime = $$v
      },
      expression: "dlgCheckOutTime"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "append-icon": "access_time",
      "clearable": "",
      "readonly": ""
    },
    on: {
      "input": function($event) {
        _vm.lAttDet.checkOutTime = null
      }
    },
    slot: "activator",
    model: {
      value: (_vm.lAttDet.checkOutTime),
      callback: function($$v) {
        _vm.$set(_vm.lAttDet, "checkOutTime", $$v)
      },
      expression: "lAttDet.checkOutTime"
    }
  }), _vm._v(" "), _c('v-time-picker', {
    model: {
      value: (_vm.lAttDet.checkOutTime),
      callback: function($$v) {
        _vm.$set(_vm.lAttDet, "checkOutTime", $$v)
      },
      expression: "lAttDet.checkOutTime"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgCheckOutTime = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dlgCheckOutTime.save(_vm.lAttDet.checkOutTime)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), (this.att_dev_type === 'FC Device' && (_vm.lAttDet.attendance === 'Present' || _vm.lAttDet.attendance === 'Half Day' || _vm.lAttDet.attendance === 'Present + OT' || _vm.lAttDet.attendance === 'Weekly Off + OT' || _vm.lAttDet.attendance === 'Holiday + OT' || _vm.lAttDet.attendance === 'Present + RL' || _vm.lAttDet.attendance === 'Casual Leave' || _vm.lAttDet.attendance === 'Earned Leave' || _vm.lAttDet.attendance === 'Sick Leave' || _vm.lAttDet.attendance === 'Comp Off')) ? _c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Reason for manual Entry",
      "maxlength": "25",
      "rules": [_vm.rules.minimum],
      "hint": "Max 30 characters "
    },
    model: {
      value: (_vm.lAttDet.remark),
      callback: function($$v) {
        _vm.$set(_vm.lAttDet, "remark", $$v)
      },
      expression: "lAttDet.remark"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Approved By",
      "maxlength": "25",
      "rules": [_vm.rules.minimum],
      "hint": "Max 15 characters "
    },
    model: {
      value: (_vm.lAttDet.approved_by),
      callback: function($$v) {
        _vm.$set(_vm.lAttDet, "approved_by", $$v)
      },
      expression: "lAttDet.approved_by"
    }
  })], 1) : (this.att_dev_type !== 'FC Device') ? _c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Remarks",
      "hint": "Max 30 characters "
    },
    model: {
      value: (_vm.lAttDet.remark),
      callback: function($$v) {
        _vm.$set(_vm.lAttDet, "remark", $$v)
      },
      expression: "lAttDet.remark"
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pt-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.dlgAttDet = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "type": "submit",
      "color": "accent",
      "disabled": _vm.beingSaved
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": _vm.sbarCol,
      "timeout": 3000,
      "multi-line": ""
    },
    model: {
      value: (_vm.sbar),
      callback: function($$v) {
        _vm.sbar = $$v
      },
      expression: "sbar"
    }
  }, [_c('span', {
    staticClass: "mx-auto"
  }, [_vm._v(_vm._s(_vm.sbarMsg))])]), _vm._v(" "), (_vm.load) ? _c('div', {
    staticStyle: {
      "position": "absolute",
      "top": "50%",
      "left": "40%"
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "info"
    }
  })], 1) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/6.249950ca4ab1ff615f03.js